
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lEX9v", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBanner", () => $a5dce79ba177b59e$export$48911bd645a2a0a2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $5qTKr = parcelRequire("5qTKr");

var $a0gOK = parcelRequire("a0gOK");


var $4zIA4 = parcelRequire("4zIA4");
const $a5dce79ba177b59e$export$48911bd645a2a0a2 = ()=>{
    const [{ height: height }] = (0, $4zIA4.useCookieConsentBannerSettings)();
    const { onDismiss: onDismiss, setHeight: setHeight } = (0, $4zIA4.useCookieConsentBannerSettingsActions)();
    const ref = (0, $eUqFw.useRef)(null);
    // banner height is set either due to screen width changes or consent banner finishes rendering
    const setBannerHeight = ()=>{
        ref.current && setHeight(ref.current.clientHeight);
    };
    // throttled banner height setter is used for dynamic banner height when screen width changes
    const throttledSetBannerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setBannerHeight, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qTKr.WidthObserver), {
        setWidth: throttledSetBannerHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            !height && "_3um015vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0gOK.ConsentBanner), {
        onHide: onDismiss,
        onShow: setBannerHeight,
        minWidth: (0, $539c74e86514eccc$export$ff6e18f7d82b549c),
        product: "Jira"
    })));
};

});
parcelRegister("a0gOK", function(module, exports) {

$parcel$export(module.exports, "ConsentBanner", () => $6b79c763184a5549$export$903b95b8397e77e9);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $f86rB = parcelRequire("f86rB");

var $XHGTv = parcelRequire("XHGTv");

var $kZ1gK = parcelRequire("kZ1gK");

var $4uLct = parcelRequire("4uLct");
var $1J3ZG = parcelRequire("1J3ZG");

var $iCiJr = parcelRequire("iCiJr");

var $6lAvk = parcelRequire("6lAvk");

var $f8OZU = parcelRequire("f8OZU");

var $dfZVK = parcelRequire("dfZVK");

var $gyZqn = parcelRequire("gyZqn");

var $2QDbD = parcelRequire("2QDbD");

var $aYdDB = parcelRequire("aYdDB");

var $cDe08 = parcelRequire("cDe08");

var $htLQp = parcelRequire("htLQp");

var $ilFhj = parcelRequire("ilFhj");
const $6b79c763184a5549$export$903b95b8397e77e9 = (props)=>{
    // Feature flag check. ESLint rules don't allow combined flags...
    if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f86rB.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b79c763184a5549$var$ConsentBannerImpl, props));
    if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f86rB.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b79c763184a5549$var$ConsentBannerImpl, props));
    return null;
};
const $6b79c763184a5549$var$ConsentBannerImpl = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, analyticsEnabled: analyticsEnabled = true })=>{
    // This flag configuration will prevent saving prefs to ConsentHub. In this
    // case we want want to show different messaging.
    const localOnlyEnvironment = (0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls') && !(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2');
    (0, $eUqFw.useEffect)(()=>{
        (0, $4uLct.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product
        });
    }, [
        analyticsEnabled,
        product
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $eUqFw.useState)(false);
    const isInitialRender = (0, $eUqFw.useRef)(true);
    const intl = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $f86rB.useFlags)();
    const { preferences: preferences } = (0, $htLQp.default)({
        isInitialRender: isInitialRender,
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $cDe08.default)({
        preferences: preferences,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender
    });
    const closePreferenceModal = (0, $eUqFw.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $eUqFw.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $eUqFw.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $1J3ZG.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $eUqFw.useCallback)(()=>{
        if (localOnlyEnvironment) showFlag({
            ...(0, $kZ1gK.successToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $gyZqn.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $gyZqn.i18n).successFlagTitle)
        });
        else showFlag({
            ...(0, $kZ1gK.successToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $gyZqn.i18n).successFlagDescription),
            title: intl.formatMessage((0, $gyZqn.i18n).successFlagTitle)
        });
    }, [
        intl,
        localOnlyEnvironment,
        showFlag
    ]);
    const showErrorFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            ...(0, $kZ1gK.errorToastProps)(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $gyZqn.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $gyZqn.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $eUqFw.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $1J3ZG.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $dfZVK.updatePreferences)((0, $f8OZU.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $1J3ZG.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $f8OZU.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $eUqFw.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $1J3ZG.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $dfZVK.updatePreferences)((0, $f8OZU.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $1J3ZG.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $f8OZU.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $eUqFw.useCallback)(()=>{
        (0, $1J3ZG.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    const prevShowBanner = (0, $ilFhj.default)(showBanner);
    (0, $eUqFw.useEffect)(()=>{
        if (showBanner && !prevShowBanner) onShow?.();
        else if (!showBanner && prevShowBanner) onHide?.();
    }, [
        showBanner,
        prevShowBanner,
        onShow,
        onHide
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f86rB.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCiJr.BSCIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYdDB.PresentationalConsentBanner), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2QDbD.PreferenceModal), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    })));
};

});
parcelRegister("kZ1gK", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $6fc64424292c70f4$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $6fc64424292c70f4$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $6fc64424292c70f4$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $6fc64424292c70f4$export$b56198a940066d8f);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");


var $ir7af = parcelRequire("ir7af");
const $6fc64424292c70f4$var$ErrorWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).error)
    }));
const $6fc64424292c70f4$var$WarningWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).warning)
    }));
const $6fc64424292c70f4$var$InfoWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        primaryColor: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$export$b48405b95304b5a1)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).info)
    }));
const $6fc64424292c70f4$var$SuccessWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).success)
    }));
const $6fc64424292c70f4$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $6fc64424292c70f4$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$WarningWithIntl, null),
        appearance: 'normal'
    });
const $6fc64424292c70f4$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$InfoWithIntl, null),
        appearance: 'normal'
    });
const $6fc64424292c70f4$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("ir7af", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb81bee64935431$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9eb81bee64935431$var$messages = (0, $90IgZ.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $9eb81bee64935431$export$2e2bcd8739ae039 = $9eb81bee64935431$var$messages;

});


parcelRegister("iCiJr", function(module, exports) {

$parcel$export(module.exports, "BSCIntlProvider", () => $7d2e828950819cab$export$9aa38aed134c207f);

var $eUqFw = parcelRequire("eUqFw");

var $3gkrZ = parcelRequire("3gkrZ");

var $pW2Oh = parcelRequire("pW2Oh");

var $ipy87 = parcelRequire("ipy87");
const $7d2e828950819cab$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3gkrZ.default), {
        defaultMessages: (0, $pW2Oh.default),
        loaderFn: (0, $ipy87.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("3gkrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4010b2d07b503ad1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $4gk3K = parcelRequire("4gk3K");

var $iU0VZ = parcelRequire("iU0VZ");
function $4010b2d07b503ad1$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $iU0VZ.useSafeIntl)();
    const messages = (0, $4gk3K.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the context and pass them downstream
	 * This prevents the missing messages error
	 */ const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("4gk3K", function(module, exports) {

$parcel$export(module.exports, "useMessages", () => $107d7c402eb4e43c$export$4d17e2d9c5348842);

var $eUqFw = parcelRequire("eUqFw");

var $1Hckl = parcelRequire("1Hckl");
const $107d7c402eb4e43c$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $eUqFw.useState)((0, $1Hckl.DEFAULT_LOCALE_STATE));
    (0, $eUqFw.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("1Hckl", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $bcc47bd05361a57b$export$79618bef82c02d4c);
const $bcc47bd05361a57b$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("iU0VZ", function(module, exports) {

$parcel$export(module.exports, "useSafeIntl", () => $5bcd56b003486e7a$export$f752ac21ea3960a5);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $aPfri = parcelRequire("aPfri");
var $2qhQi = parcelRequire("2qhQi");

var $1Hckl = parcelRequire("1Hckl");
// Prevents memory leaks
const $5bcd56b003486e7a$var$cache = (0, $aPfri.createIntlCache)();
const $5bcd56b003486e7a$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $2qhQi.Context));
    if (!context) return (0, $3dpxL.createIntl)((0, $1Hckl.DEFAULT_LOCALE_STATE), $5bcd56b003486e7a$var$cache);
    return context;
};

});


parcelRegister("pW2Oh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bbb1393c93dd425$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6bbb1393c93dd425$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.082624': 'Measures usage to improve product performance',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.description': "We respect your right to privacy, so you can select which cookies you allow. However, <bold>strictly necessary</bold> cookies are always allowed as they're essential for our products to function. They don't store any personally identifiable information or track your browsing habits. {link}",
    'browser-storage-controls.consent-banner-modal.functional.description': "These cookies enable our product to provide enhanced functionality and personalization. They may be set by us or by third party providers whose services we've added to our pages. If you don't allow these cookies, some or all of these services may not function properly.",
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.performance.description': "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our product. All the information these cookies collect is aggregated and therefore anonymous. If you don't allow these cookies, we won't know when you've visited our product and won't be able to monitor its performance.",
    'browser-storage-controls.consent-banner-modal.performance.option': 'Allow performance cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.targeting.description': "These cookies may be set through our product by our partners. They don't store directly personal information, but are based on identifying your unique browser and internet device. If you don't allow these cookies, you'll experience less targeted advertising.",
    'browser-storage-controls.consent-banner-modal.targeting.option': 'Allow targeting cookies',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link': 'Atlassian cookies and Tracking notice',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text': 'Atlassian cookies and Tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved'
};

});

parcelRegister("ipy87", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $404d8b8836fd2252$export$2b153a2030b0feb2);
const $404d8b8836fd2252$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */ `../../../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */ `../../../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});


parcelRegister("dfZVK", function(module, exports) {

$parcel$export(module.exports, "updatePreferences", () => $2e7b4b010243bfc2$export$7bb3e177c1a1e841);

var $XHGTv = parcelRequire("XHGTv");

var $f8OZU = parcelRequire("f8OZU");

var $epRiJ = parcelRequire("epRiJ");

var $2amVy = parcelRequire("2amVy");

var $lIW4M = parcelRequire("lIW4M");

var $huW21 = parcelRequire("huW21");
const $2e7b4b010243bfc2$var$emptyDisplayedTextMap = {
    [(0, $epRiJ.PreferenceCategory).Analytics]: '',
    [(0, $epRiJ.PreferenceCategory).Functional]: '',
    [(0, $epRiJ.PreferenceCategory).Marketing]: '',
    [(0, $epRiJ.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $epRiJ.PreferenceCategory).Unknown]: ''
};
async function $2e7b4b010243bfc2$export$7bb3e177c1a1e841(preferences, displayedTextMap = $2e7b4b010243bfc2$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) {
        const packedPrefs = (0, $huW21.packUserPreferences)(preferences);
        (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $2amVy.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("2amVy", function(module, exports) {

$parcel$export(module.exports, "setConsentToken", () => $53a76119918655e8$export$fbf549fe6f0e91dc);

var $6lAvk = parcelRequire("6lAvk");

var $dEf7A = parcelRequire("dEf7A");

var $k6AXN = parcelRequire("k6AXN");

var $epRiJ = parcelRequire("epRiJ");

var $4TcP6 = parcelRequire("4TcP6");

var $huW21 = parcelRequire("huW21");

var $4PR4e = parcelRequire("4PR4e");
const $53a76119918655e8$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $huW21.packUserPreferences)(mergedPrefs);
    // If the token is prefetched and a default, we should rely on the existing cookie data rather than re-setting
    // cookies that are already set
    const tokenIsPrefetchedDefault = usingPrefetchedData && (0, $k6AXN.checkIfTokenIsDefault)(consentToken);
    if (!tokenIsPrefetchedDefault) {
        if (usingPrefetchedData) // If the fallback token already exists, we don't want to nuke the expiration inadvertently (since this happens on every page load).
        (0, $4PR4e.onlySetFallbackIfDifferent)(consentToken);
        else // This has originated from a user saving their consents in the UI, so set a fallback to their new consents immediately.
        (0, $4TcP6.setConsentTokenFallbackCookie)(consentToken);
        (0, $4TcP6.setConsentTokenCookie)(consentToken);
        (0, $4TcP6.setShouldShowBannerCookie)(consentToken);
    }
};
const $53a76119918655e8$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $k6AXN.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $k6AXN.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $epRiJ.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $huW21.packUserPreferences)({
        ...mergedPrefs,
        [(0, $epRiJ.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $epRiJ.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $6lAvk.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $4PR4e.onlySetFallbackIfDifferent)(consentToken);
        (0, $4TcP6.setConsentTokenCookie)(consentToken);
        (0, $4TcP6.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $6lAvk.Logger).error('Token failed to save');
    (0, $4PR4e.onlySetFallbackIfDifferent)(consentToken);
    (0, $4TcP6.setShouldShowBannerCookie)(consentToken);
};
const $53a76119918655e8$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $4PR4e.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $dEf7A.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $53a76119918655e8$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $53a76119918655e8$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("4TcP6", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", () => $5947d7e9e7fd3832$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $5947d7e9e7fd3832$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $5947d7e9e7fd3832$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $5947d7e9e7fd3832$export$b3365240280cb3c3);

var $fP0zk = parcelRequire("fP0zk");

var $f8OZU = parcelRequire("f8OZU");

var $40nlu = parcelRequire("40nlu");

var $lIW4M = parcelRequire("lIW4M");
const $5947d7e9e7fd3832$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $5947d7e9e7fd3832$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
};
const $5947d7e9e7fd3832$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $40nlu.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $fP0zk.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $lIW4M.setStrictlyNecessaryCookie)((0, $f8OZU.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $5947d7e9e7fd3832$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $5947d7e9e7fd3832$export$8e560d0760f733a2(consentToken);
    $5947d7e9e7fd3832$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("lIW4M", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $6d2869955a851487$export$93509ff9a62ee022);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $6lAvk = parcelRequire("6lAvk");
const $6d2869955a851487$export$93509ff9a62ee022 = (key, value, attributes)=>{
    try {
        if ((0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) (0, $1J3ZG.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $6lAvk.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("4PR4e", function(module, exports) {

$parcel$export(module.exports, "mergeConsentUpdates", () => $f9a0ef663520689f$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $f9a0ef663520689f$export$a023a0b818522757);

var $f8OZU = parcelRequire("f8OZU");

var $epRiJ = parcelRequire("epRiJ");

var $b4VDn = parcelRequire("b4VDn");

var $4TcP6 = parcelRequire("4TcP6");

var $huW21 = parcelRequire("huW21");
const $f9a0ef663520689f$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $epRiJ.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $epRiJ.PreferenceCategory).StrictlyNecessary],
        [(0, $epRiJ.PreferenceCategory).Functional]: updatedPreferences[(0, $epRiJ.PreferenceCategory).Functional],
        [(0, $epRiJ.PreferenceCategory).Analytics]: updatedPreferences[(0, $epRiJ.PreferenceCategory).Analytics],
        [(0, $epRiJ.PreferenceCategory).Marketing]: updatedPreferences[(0, $epRiJ.PreferenceCategory).Marketing],
        [(0, $epRiJ.PreferenceCategory).Unknown]: updatedPreferences[(0, $epRiJ.PreferenceCategory).Unknown]
    };
};
const $f9a0ef663520689f$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $epRiJ.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $epRiJ.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $epRiJ.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $epRiJ.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $epRiJ.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $epRiJ.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $f9a0ef663520689f$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $huW21.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $f8OZU.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$f9a0ef663520689f$var$pruneLegacyProperties(updatedPreferences),
            ...$f9a0ef663520689f$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $f8OZU.DEFAULT_PREFERENCES),
            ...$f9a0ef663520689f$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $f8OZU.DEFAULT_PREFERENCES),
        ...$f9a0ef663520689f$var$pruneLegacyProperties(updatedPreferences),
        ...$f9a0ef663520689f$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $f9a0ef663520689f$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $4TcP6.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("gyZqn", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $300f31a0f26c5310$export$a7357cdd1f0b0168);

var $90IgZ = parcelRequire("90IgZ");
const $300f31a0f26c5310$export$a7357cdd1f0b0168 = (0, $90IgZ.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text',
        defaultMessage: 'Atlassian cookies and Tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("2QDbD", function(module, exports) {

$parcel$export(module.exports, "PreferenceModal", () => $3f9363958370c0fc$export$94c5684831c222e7);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $6lAvk = parcelRequire("6lAvk");

var $dfZVK = parcelRequire("dfZVK");

var $epRiJ = parcelRequire("epRiJ");

var $9Szmk = parcelRequire("9Szmk");
const $3f9363958370c0fc$export$94c5684831c222e7 = (props)=>{
    // feature flag check
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f9363958370c0fc$export$30df3cfccbe10e6e, props);
};
const $3f9363958370c0fc$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag })=>{
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(true);
    const isEventSent = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $1J3ZG.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const [preferences, setPreferences] = (0, $eUqFw.useState)({
        [(0, $epRiJ.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $epRiJ.PreferenceCategory).Functional]: false,
        [(0, $epRiJ.PreferenceCategory).Marketing]: false,
        [(0, $epRiJ.PreferenceCategory).Analytics]: false,
        [(0, $epRiJ.PreferenceCategory).Unknown]: false
    });
    const handleOnSubmit = (0, $eUqFw.useCallback)(async (displayedTextMap)=>{
        const selectedPreferences = preferences;
        (0, $1J3ZG.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'confirm',
            source: 'cookieConsentModal'
        });
        try {
            await (0, $dfZVK.updatePreferences)(selectedPreferences, displayedTextMap);
            (0, $1J3ZG.sendTrackEvent)({
                source: 'cookieConsentModal',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag?.();
        } catch (e) {
            (0, $6lAvk.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: selectedPreferences
                },
                message: `Failed to update preferences from modal. ${e.message || ''}`
            });
            showErrorFlag?.();
        }
        setIsModalOpen(false);
        onSubmit?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Szmk.PresentationalPreferenceModal), {
        setPreferences: setPreferences,
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences
    }));
};

});
parcelRegister("9Szmk", function(module, exports) {

$parcel$export(module.exports, "PresentationalPreferenceModal", () => $5d356cca7a5bbedd$export$9921ee7829a3ba4);

var $eUqFw = parcelRequire("eUqFw");

var $4ksuc = parcelRequire("4ksuc");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7u4fN = parcelRequire("7u4fN");

var $lzLxZ = parcelRequire("lzLxZ");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $4kMup = parcelRequire("4kMup");
var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $1J3ZG = parcelRequire("1J3ZG");

var $cO5lu = parcelRequire("cO5lu");

var $epRiJ = parcelRequire("epRiJ");

var $25WOM = parcelRequire("25WOM");

var $chqoM = parcelRequire("chqoM");
const $5d356cca7a5bbedd$var$categoryNameStyles = (0, $1ZAYh.xcss)({
    fontWeight: 'bold'
});
const $5d356cca7a5bbedd$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $chqoM.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $chqoM.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $chqoM.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = (0, (/*@__PURE__*/$parcel$interopDefault($4ksuc))).renderToStaticMarkup(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    // This outputs an encoded string that jacks up apostrophes, so clean 'em up
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $5d356cca7a5bbedd$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $epRiJ.PreferenceCategory).Functional,
            title: (0, $chqoM.i18n).functionalOption,
            description: (0, $chqoM.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $epRiJ.PreferenceCategory).Analytics,
            title: (0, $chqoM.i18n).analyticalOption,
            description: (0, $chqoM.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $epRiJ.PreferenceCategory).Marketing,
            title: (0, $chqoM.i18n).marketingOption,
            description: (0, $chqoM.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $cO5lu.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $5d356cca7a5bbedd$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $5d356cca7a5bbedd$var$categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $5d356cca7a5bbedd$var$noop = ()=>{};
const $5d356cca7a5bbedd$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferences: setPreferences = $5d356cca7a5bbedd$var$noop, onSubmit: onSubmit = $5d356cca7a5bbedd$var$noop, onClose: onClose = $5d356cca7a5bbedd$var$noop, setIsOpen: setIsOpen = $5d356cca7a5bbedd$var$noop })=>{
    const intl = (0, $5JgJ2.default)();
    const onCloseModal = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $eUqFw.useCallback)(()=>{
        onCloseModal();
        (0, $1J3ZG.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $eUqFw.useCallback)(()=>{
        onCloseModal();
        (0, $1J3ZG.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $eUqFw.useCallback)(()=>{
        (0, $1J3ZG.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $eUqFw.useMemo)(()=>{
        return $5d356cca7a5bbedd$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $eUqFw.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClickBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: handleSubmission
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $chqoM.i18n).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $chqoM.i18n).summaryDescription,
            values: {
                link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                    href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                    target: "_blank",
                    onClick: onClickTrackingNoticeLink
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $chqoM.i18n).trackingLink))
            },
            tagName: 'p'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $chqoM.i18n).strictDescription,
            values: {
                bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, msg)
            },
            tagName: 'p'
        })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $25WOM.CookieCategorySection), {
                category: category,
                titleElement: titleElement,
                titleString: titleString,
                descriptionElement: description,
                isChecked: preferences[category] ?? false,
                setPreferences: setPreferences
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: onClickCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $chqoM.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            type: "submit",
            appearance: "primary",
            onClick: handleSubmission
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $chqoM.i18n).confirmBtn)))))));
};

});
parcelRegister("4ksuc", function(module, exports) {

$parcel$export(module.exports, "version", () => $326f2072f29cfed1$export$83d89fbfd8236492, (v) => $326f2072f29cfed1$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "renderToString", () => $326f2072f29cfed1$export$80e7718417253a51, (v) => $326f2072f29cfed1$export$80e7718417253a51 = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $326f2072f29cfed1$export$eb3a06aef9e6ee51, (v) => $326f2072f29cfed1$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToNodeStream", () => $326f2072f29cfed1$export$307591e98609eddd, (v) => $326f2072f29cfed1$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $326f2072f29cfed1$export$b23711c915539651, (v) => $326f2072f29cfed1$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToReadableStream", () => $326f2072f29cfed1$export$7020a3240b287705, (v) => $326f2072f29cfed1$export$7020a3240b287705 = v);
var $326f2072f29cfed1$export$83d89fbfd8236492;
var $326f2072f29cfed1$export$80e7718417253a51;
var $326f2072f29cfed1$export$eb3a06aef9e6ee51;
var $326f2072f29cfed1$export$307591e98609eddd;
var $326f2072f29cfed1$export$b23711c915539651;
var $326f2072f29cfed1$export$7020a3240b287705;
'use strict';
var $326f2072f29cfed1$var$l, $326f2072f29cfed1$var$s;

$326f2072f29cfed1$var$l = (parcelRequire("hEssg"));

$326f2072f29cfed1$var$s = (parcelRequire("j9HRh"));
$326f2072f29cfed1$export$83d89fbfd8236492 = $326f2072f29cfed1$var$l.version;
$326f2072f29cfed1$export$80e7718417253a51 = $326f2072f29cfed1$var$l.renderToString;
$326f2072f29cfed1$export$eb3a06aef9e6ee51 = $326f2072f29cfed1$var$l.renderToStaticMarkup;
$326f2072f29cfed1$export$307591e98609eddd = $326f2072f29cfed1$var$l.renderToNodeStream;
$326f2072f29cfed1$export$b23711c915539651 = $326f2072f29cfed1$var$l.renderToStaticNodeStream;
$326f2072f29cfed1$export$7020a3240b287705 = $326f2072f29cfed1$var$s.renderToReadableStream;

});
parcelRegister("hEssg", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $cd9c3ea3cc3a0d08$export$307591e98609eddd, (v) => $cd9c3ea3cc3a0d08$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $cd9c3ea3cc3a0d08$export$eb3a06aef9e6ee51, (v) => $cd9c3ea3cc3a0d08$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $cd9c3ea3cc3a0d08$export$b23711c915539651, (v) => $cd9c3ea3cc3a0d08$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $cd9c3ea3cc3a0d08$export$80e7718417253a51, (v) => $cd9c3ea3cc3a0d08$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $cd9c3ea3cc3a0d08$export$83d89fbfd8236492, (v) => $cd9c3ea3cc3a0d08$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cd9c3ea3cc3a0d08$export$307591e98609eddd;
var $cd9c3ea3cc3a0d08$export$eb3a06aef9e6ee51;
var $cd9c3ea3cc3a0d08$export$b23711c915539651;
var $cd9c3ea3cc3a0d08$export$80e7718417253a51;
var $cd9c3ea3cc3a0d08$export$83d89fbfd8236492;
'use strict';

var $eUqFw = parcelRequire("eUqFw");
function $cd9c3ea3cc3a0d08$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $cd9c3ea3cc3a0d08$var$p = Object.prototype.hasOwnProperty, $cd9c3ea3cc3a0d08$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $cd9c3ea3cc3a0d08$var$ha = {}, $cd9c3ea3cc3a0d08$var$ia = {};
function $cd9c3ea3cc3a0d08$var$ja(a) {
    if ($cd9c3ea3cc3a0d08$var$p.call($cd9c3ea3cc3a0d08$var$ia, a)) return !0;
    if ($cd9c3ea3cc3a0d08$var$p.call($cd9c3ea3cc3a0d08$var$ha, a)) return !1;
    if ($cd9c3ea3cc3a0d08$var$fa.test(a)) return $cd9c3ea3cc3a0d08$var$ia[a] = !0;
    $cd9c3ea3cc3a0d08$var$ha[a] = !0;
    return !1;
}
function $cd9c3ea3cc3a0d08$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $cd9c3ea3cc3a0d08$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $cd9c3ea3cc3a0d08$var$t[b] = new $cd9c3ea3cc3a0d08$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $cd9c3ea3cc3a0d08$var$ka = /[\-:]([a-z])/g;
function $cd9c3ea3cc3a0d08$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($cd9c3ea3cc3a0d08$var$ka, $cd9c3ea3cc3a0d08$var$la);
    $cd9c3ea3cc3a0d08$var$t[b] = new $cd9c3ea3cc3a0d08$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($cd9c3ea3cc3a0d08$var$ka, $cd9c3ea3cc3a0d08$var$la);
    $cd9c3ea3cc3a0d08$var$t[b] = new $cd9c3ea3cc3a0d08$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($cd9c3ea3cc3a0d08$var$ka, $cd9c3ea3cc3a0d08$var$la);
    $cd9c3ea3cc3a0d08$var$t[b] = new $cd9c3ea3cc3a0d08$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$cd9c3ea3cc3a0d08$var$t.xlinkHref = new $cd9c3ea3cc3a0d08$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$t[a] = new $cd9c3ea3cc3a0d08$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $cd9c3ea3cc3a0d08$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $cd9c3ea3cc3a0d08$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($cd9c3ea3cc3a0d08$var$u).forEach(function(a) {
    $cd9c3ea3cc3a0d08$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $cd9c3ea3cc3a0d08$var$u[b] = $cd9c3ea3cc3a0d08$var$u[a];
    });
});
var $cd9c3ea3cc3a0d08$var$na = /["'&<>]/;
function $cd9c3ea3cc3a0d08$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $cd9c3ea3cc3a0d08$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $cd9c3ea3cc3a0d08$var$oa = /([A-Z])/g, $cd9c3ea3cc3a0d08$var$pa = /^ms-/, $cd9c3ea3cc3a0d08$var$qa = Array.isArray;
function $cd9c3ea3cc3a0d08$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $cd9c3ea3cc3a0d08$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $cd9c3ea3cc3a0d08$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $cd9c3ea3cc3a0d08$var$w(2, null);
        case "math":
            return $cd9c3ea3cc3a0d08$var$w(3, null);
        case "foreignObject":
            return $cd9c3ea3cc3a0d08$var$w(1, null);
        case "table":
            return $cd9c3ea3cc3a0d08$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $cd9c3ea3cc3a0d08$var$w(5, null);
        case "colgroup":
            return $cd9c3ea3cc3a0d08$var$w(7, null);
        case "tr":
            return $cd9c3ea3cc3a0d08$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $cd9c3ea3cc3a0d08$var$w(1, null) : a;
}
var $cd9c3ea3cc3a0d08$var$sa = new Map;
function $cd9c3ea3cc3a0d08$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($cd9c3ea3cc3a0d08$var$l(62));
    b = !0;
    for(var d in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $cd9c3ea3cc3a0d08$var$v(d);
                f = $cd9c3ea3cc3a0d08$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $cd9c3ea3cc3a0d08$var$sa.get(e);
                void 0 !== g ? e = g : (g = $cd9c3ea3cc3a0d08$var$v(e.replace($cd9c3ea3cc3a0d08$var$oa, "-$1").toLowerCase().replace($cd9c3ea3cc3a0d08$var$pa, "-ms-")), $cd9c3ea3cc3a0d08$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $cd9c3ea3cc3a0d08$var$p.call($cd9c3ea3cc3a0d08$var$u, d) ? "" + f : f + "px" : $cd9c3ea3cc3a0d08$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $cd9c3ea3cc3a0d08$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $cd9c3ea3cc3a0d08$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $cd9c3ea3cc3a0d08$var$t.hasOwnProperty(c) ? $cd9c3ea3cc3a0d08$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $cd9c3ea3cc3a0d08$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $cd9c3ea3cc3a0d08$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $cd9c3ea3cc3a0d08$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $cd9c3ea3cc3a0d08$var$v(d), '"');
            }
        } else if ($cd9c3ea3cc3a0d08$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $cd9c3ea3cc3a0d08$var$v(d), '"');
        }
    }
}
function $cd9c3ea3cc3a0d08$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($cd9c3ea3cc3a0d08$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($cd9c3ea3cc3a0d08$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $cd9c3ea3cc3a0d08$var$ua(a) {
    var b = "";
    $eUqFw.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $cd9c3ea3cc3a0d08$var$va(a, b, c, d) {
    a.push($cd9c3ea3cc3a0d08$var$A(c));
    var f = c = null, e;
    for(e in b)if ($cd9c3ea3cc3a0d08$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $cd9c3ea3cc3a0d08$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $cd9c3ea3cc3a0d08$var$y(a, f, c);
    return "string" === typeof c ? (a.push($cd9c3ea3cc3a0d08$var$v(c)), null) : c;
}
var $cd9c3ea3cc3a0d08$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $cd9c3ea3cc3a0d08$var$xa = new Map;
function $cd9c3ea3cc3a0d08$var$A(a) {
    var b = $cd9c3ea3cc3a0d08$var$xa.get(a);
    if (void 0 === b) {
        if (!$cd9c3ea3cc3a0d08$var$wa.test(a)) throw Error($cd9c3ea3cc3a0d08$var$l(65, a));
        b = "<" + a;
        $cd9c3ea3cc3a0d08$var$xa.set(a, b);
    }
    return b;
}
function $cd9c3ea3cc3a0d08$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($cd9c3ea3cc3a0d08$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $cd9c3ea3cc3a0d08$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $cd9c3ea3cc3a0d08$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($cd9c3ea3cc3a0d08$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $cd9c3ea3cc3a0d08$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $cd9c3ea3cc3a0d08$var$ua(h), $cd9c3ea3cc3a0d08$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $cd9c3ea3cc3a0d08$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($cd9c3ea3cc3a0d08$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($cd9c3ea3cc3a0d08$var$l(91));
                default:
                    $cd9c3ea3cc3a0d08$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($cd9c3ea3cc3a0d08$var$l(92));
                if ($cd9c3ea3cc3a0d08$var$qa(n) && 1 < n.length) throw Error($cd9c3ea3cc3a0d08$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($cd9c3ea3cc3a0d08$var$v("" + e));
            return null;
        case "input":
            a.push($cd9c3ea3cc3a0d08$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($cd9c3ea3cc3a0d08$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $cd9c3ea3cc3a0d08$var$x(a, d, g, m);
            }
            null !== n ? $cd9c3ea3cc3a0d08$var$x(a, d, "checked", n) : null !== k && $cd9c3ea3cc3a0d08$var$x(a, d, "checked", k);
            null !== e ? $cd9c3ea3cc3a0d08$var$x(a, d, "value", e) : null !== h && $cd9c3ea3cc3a0d08$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($cd9c3ea3cc3a0d08$var$A("menuitem"));
            for(var C in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($cd9c3ea3cc3a0d08$var$l(400));
                default:
                    $cd9c3ea3cc3a0d08$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($cd9c3ea3cc3a0d08$var$A("title"));
            e = null;
            for(q in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($cd9c3ea3cc3a0d08$var$l(434));
                default:
                    $cd9c3ea3cc3a0d08$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($cd9c3ea3cc3a0d08$var$A(b));
            g = e = null;
            for(k in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $cd9c3ea3cc3a0d08$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($cd9c3ea3cc3a0d08$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($cd9c3ea3cc3a0d08$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($cd9c3ea3cc3a0d08$var$A(b));
            for(var D in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($cd9c3ea3cc3a0d08$var$l(399, b));
                default:
                    $cd9c3ea3cc3a0d08$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $cd9c3ea3cc3a0d08$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $cd9c3ea3cc3a0d08$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $cd9c3ea3cc3a0d08$var$va(a, c, b, d);
            a.push($cd9c3ea3cc3a0d08$var$A(b));
            g = e = null;
            for(m in c)if ($cd9c3ea3cc3a0d08$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $cd9c3ea3cc3a0d08$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $cd9c3ea3cc3a0d08$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $cd9c3ea3cc3a0d08$var$v(h), '"');
            }
            a.push(">");
            $cd9c3ea3cc3a0d08$var$y(a, g, e);
            return e;
    }
}
function $cd9c3ea3cc3a0d08$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($cd9c3ea3cc3a0d08$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $cd9c3ea3cc3a0d08$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($cd9c3ea3cc3a0d08$var$l(397));
    }
}
function $cd9c3ea3cc3a0d08$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($cd9c3ea3cc3a0d08$var$l(397));
    }
}
var $cd9c3ea3cc3a0d08$var$Ca = /[<\u2028\u2029]/g;
function $cd9c3ea3cc3a0d08$var$Da(a) {
    return JSON.stringify(a).replace($cd9c3ea3cc3a0d08$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $cd9c3ea3cc3a0d08$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $cd9c3ea3cc3a0d08$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($cd9c3ea3cc3a0d08$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($cd9c3ea3cc3a0d08$var$v(b)), a = !0);
    return a;
}
var $cd9c3ea3cc3a0d08$var$B = Object.assign, $cd9c3ea3cc3a0d08$var$Ga = Symbol.for("react.element"), $cd9c3ea3cc3a0d08$var$Ha = Symbol.for("react.portal"), $cd9c3ea3cc3a0d08$var$Ia = Symbol.for("react.fragment"), $cd9c3ea3cc3a0d08$var$Ja = Symbol.for("react.strict_mode"), $cd9c3ea3cc3a0d08$var$Ka = Symbol.for("react.profiler"), $cd9c3ea3cc3a0d08$var$La = Symbol.for("react.provider"), $cd9c3ea3cc3a0d08$var$Ma = Symbol.for("react.context"), $cd9c3ea3cc3a0d08$var$Na = Symbol.for("react.forward_ref"), $cd9c3ea3cc3a0d08$var$Oa = Symbol.for("react.suspense"), $cd9c3ea3cc3a0d08$var$Pa = Symbol.for("react.suspense_list"), $cd9c3ea3cc3a0d08$var$Qa = Symbol.for("react.memo"), $cd9c3ea3cc3a0d08$var$Ra = Symbol.for("react.lazy"), $cd9c3ea3cc3a0d08$var$Sa = Symbol.for("react.scope"), $cd9c3ea3cc3a0d08$var$Ta = Symbol.for("react.debug_trace_mode"), $cd9c3ea3cc3a0d08$var$Ua = Symbol.for("react.legacy_hidden"), $cd9c3ea3cc3a0d08$var$Va = Symbol.for("react.default_value"), $cd9c3ea3cc3a0d08$var$Wa = Symbol.iterator;
function $cd9c3ea3cc3a0d08$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $cd9c3ea3cc3a0d08$var$Ia:
            return "Fragment";
        case $cd9c3ea3cc3a0d08$var$Ha:
            return "Portal";
        case $cd9c3ea3cc3a0d08$var$Ka:
            return "Profiler";
        case $cd9c3ea3cc3a0d08$var$Ja:
            return "StrictMode";
        case $cd9c3ea3cc3a0d08$var$Oa:
            return "Suspense";
        case $cd9c3ea3cc3a0d08$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $cd9c3ea3cc3a0d08$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $cd9c3ea3cc3a0d08$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $cd9c3ea3cc3a0d08$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $cd9c3ea3cc3a0d08$var$Qa:
            return b = a.displayName || null, null !== b ? b : $cd9c3ea3cc3a0d08$var$Xa(a.type) || "Memo";
        case $cd9c3ea3cc3a0d08$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $cd9c3ea3cc3a0d08$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $cd9c3ea3cc3a0d08$var$Ya = {};
function $cd9c3ea3cc3a0d08$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $cd9c3ea3cc3a0d08$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $cd9c3ea3cc3a0d08$var$E = null;
function $cd9c3ea3cc3a0d08$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($cd9c3ea3cc3a0d08$var$l(401));
        } else {
            if (null === c) throw Error($cd9c3ea3cc3a0d08$var$l(401));
            $cd9c3ea3cc3a0d08$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $cd9c3ea3cc3a0d08$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $cd9c3ea3cc3a0d08$var$$a(a);
}
function $cd9c3ea3cc3a0d08$var$ab(a) {
    var b = a.parent;
    null !== b && $cd9c3ea3cc3a0d08$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $cd9c3ea3cc3a0d08$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($cd9c3ea3cc3a0d08$var$l(402));
    a.depth === b.depth ? $cd9c3ea3cc3a0d08$var$F(a, b) : $cd9c3ea3cc3a0d08$var$bb(a, b);
}
function $cd9c3ea3cc3a0d08$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($cd9c3ea3cc3a0d08$var$l(402));
    a.depth === c.depth ? $cd9c3ea3cc3a0d08$var$F(a, c) : $cd9c3ea3cc3a0d08$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $cd9c3ea3cc3a0d08$var$G(a) {
    var b = $cd9c3ea3cc3a0d08$var$E;
    b !== a && (null === b ? $cd9c3ea3cc3a0d08$var$ab(a) : null === a ? $cd9c3ea3cc3a0d08$var$$a(b) : b.depth === a.depth ? $cd9c3ea3cc3a0d08$var$F(b, a) : b.depth > a.depth ? $cd9c3ea3cc3a0d08$var$bb(b, a) : $cd9c3ea3cc3a0d08$var$cb(b, a), $cd9c3ea3cc3a0d08$var$E = a);
}
var $cd9c3ea3cc3a0d08$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $cd9c3ea3cc3a0d08$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $cd9c3ea3cc3a0d08$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $cd9c3ea3cc3a0d08$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $cd9c3ea3cc3a0d08$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $cd9c3ea3cc3a0d08$var$B({}, e, h)) : $cd9c3ea3cc3a0d08$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $cd9c3ea3cc3a0d08$var$fb = {
    id: 1,
    overflow: ""
};
function $cd9c3ea3cc3a0d08$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $cd9c3ea3cc3a0d08$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $cd9c3ea3cc3a0d08$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $cd9c3ea3cc3a0d08$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $cd9c3ea3cc3a0d08$var$H = Math.clz32 ? Math.clz32 : $cd9c3ea3cc3a0d08$var$hb, $cd9c3ea3cc3a0d08$var$ib = Math.log, $cd9c3ea3cc3a0d08$var$jb = Math.LN2;
function $cd9c3ea3cc3a0d08$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($cd9c3ea3cc3a0d08$var$ib(a) / $cd9c3ea3cc3a0d08$var$jb | 0) | 0;
}
function $cd9c3ea3cc3a0d08$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $cd9c3ea3cc3a0d08$var$lb = "function" === typeof Object.is ? Object.is : $cd9c3ea3cc3a0d08$var$kb, $cd9c3ea3cc3a0d08$var$I = null, $cd9c3ea3cc3a0d08$var$ob = null, $cd9c3ea3cc3a0d08$var$J = null, $cd9c3ea3cc3a0d08$var$K = null, $cd9c3ea3cc3a0d08$var$L = !1, $cd9c3ea3cc3a0d08$var$M = !1, $cd9c3ea3cc3a0d08$var$N = 0, $cd9c3ea3cc3a0d08$var$O = null, $cd9c3ea3cc3a0d08$var$P = 0;
function $cd9c3ea3cc3a0d08$var$Q() {
    if (null === $cd9c3ea3cc3a0d08$var$I) throw Error($cd9c3ea3cc3a0d08$var$l(321));
    return $cd9c3ea3cc3a0d08$var$I;
}
function $cd9c3ea3cc3a0d08$var$pb() {
    if (0 < $cd9c3ea3cc3a0d08$var$P) throw Error($cd9c3ea3cc3a0d08$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $cd9c3ea3cc3a0d08$var$qb() {
    null === $cd9c3ea3cc3a0d08$var$K ? null === $cd9c3ea3cc3a0d08$var$J ? ($cd9c3ea3cc3a0d08$var$L = !1, $cd9c3ea3cc3a0d08$var$J = $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$pb()) : ($cd9c3ea3cc3a0d08$var$L = !0, $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$J) : null === $cd9c3ea3cc3a0d08$var$K.next ? ($cd9c3ea3cc3a0d08$var$L = !1, $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$K.next = $cd9c3ea3cc3a0d08$var$pb()) : ($cd9c3ea3cc3a0d08$var$L = !0, $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$K.next);
    return $cd9c3ea3cc3a0d08$var$K;
}
function $cd9c3ea3cc3a0d08$var$rb() {
    $cd9c3ea3cc3a0d08$var$ob = $cd9c3ea3cc3a0d08$var$I = null;
    $cd9c3ea3cc3a0d08$var$M = !1;
    $cd9c3ea3cc3a0d08$var$J = null;
    $cd9c3ea3cc3a0d08$var$P = 0;
    $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$O = null;
}
function $cd9c3ea3cc3a0d08$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $cd9c3ea3cc3a0d08$var$tb(a, b, c) {
    $cd9c3ea3cc3a0d08$var$I = $cd9c3ea3cc3a0d08$var$Q();
    $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$qb();
    if ($cd9c3ea3cc3a0d08$var$L) {
        var d = $cd9c3ea3cc3a0d08$var$K.queue;
        b = d.dispatch;
        if (null !== $cd9c3ea3cc3a0d08$var$O && (c = $cd9c3ea3cc3a0d08$var$O.get(d), void 0 !== c)) {
            $cd9c3ea3cc3a0d08$var$O.delete(d);
            d = $cd9c3ea3cc3a0d08$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $cd9c3ea3cc3a0d08$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $cd9c3ea3cc3a0d08$var$K.memoizedState,
            b
        ];
    }
    a = a === $cd9c3ea3cc3a0d08$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $cd9c3ea3cc3a0d08$var$K.memoizedState = a;
    a = $cd9c3ea3cc3a0d08$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $cd9c3ea3cc3a0d08$var$ub.bind(null, $cd9c3ea3cc3a0d08$var$I, a);
    return [
        $cd9c3ea3cc3a0d08$var$K.memoizedState,
        a
    ];
}
function $cd9c3ea3cc3a0d08$var$vb(a, b) {
    $cd9c3ea3cc3a0d08$var$I = $cd9c3ea3cc3a0d08$var$Q();
    $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $cd9c3ea3cc3a0d08$var$K) {
        var c = $cd9c3ea3cc3a0d08$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$cd9c3ea3cc3a0d08$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $cd9c3ea3cc3a0d08$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cd9c3ea3cc3a0d08$var$ub(a, b, c) {
    if (25 <= $cd9c3ea3cc3a0d08$var$P) throw Error($cd9c3ea3cc3a0d08$var$l(301));
    if (a === $cd9c3ea3cc3a0d08$var$I) {
        if ($cd9c3ea3cc3a0d08$var$M = !0, a = {
            action: c,
            next: null
        }, null === $cd9c3ea3cc3a0d08$var$O && ($cd9c3ea3cc3a0d08$var$O = new Map), c = $cd9c3ea3cc3a0d08$var$O.get(b), void 0 === c) $cd9c3ea3cc3a0d08$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $cd9c3ea3cc3a0d08$var$wb() {
    throw Error($cd9c3ea3cc3a0d08$var$l(394));
}
function $cd9c3ea3cc3a0d08$var$R() {}
var $cd9c3ea3cc3a0d08$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $cd9c3ea3cc3a0d08$var$Q();
        return a._currentValue2;
    },
    useMemo: $cd9c3ea3cc3a0d08$var$vb,
    useReducer: $cd9c3ea3cc3a0d08$var$tb,
    useRef: function(a) {
        $cd9c3ea3cc3a0d08$var$I = $cd9c3ea3cc3a0d08$var$Q();
        $cd9c3ea3cc3a0d08$var$K = $cd9c3ea3cc3a0d08$var$qb();
        var b = $cd9c3ea3cc3a0d08$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $cd9c3ea3cc3a0d08$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $cd9c3ea3cc3a0d08$var$tb($cd9c3ea3cc3a0d08$var$sb, a);
    },
    useInsertionEffect: $cd9c3ea3cc3a0d08$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $cd9c3ea3cc3a0d08$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $cd9c3ea3cc3a0d08$var$R,
    useEffect: $cd9c3ea3cc3a0d08$var$R,
    useDebugValue: $cd9c3ea3cc3a0d08$var$R,
    useDeferredValue: function(a) {
        $cd9c3ea3cc3a0d08$var$Q();
        return a;
    },
    useTransition: function() {
        $cd9c3ea3cc3a0d08$var$Q();
        return [
            !1,
            $cd9c3ea3cc3a0d08$var$wb
        ];
    },
    useId: function() {
        var a = $cd9c3ea3cc3a0d08$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $cd9c3ea3cc3a0d08$var$H(a) - 1)).toString(32) + b;
        var c = $cd9c3ea3cc3a0d08$var$S;
        if (null === c) throw Error($cd9c3ea3cc3a0d08$var$l(404));
        b = $cd9c3ea3cc3a0d08$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $cd9c3ea3cc3a0d08$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($cd9c3ea3cc3a0d08$var$l(407));
        return c();
    }
}, $cd9c3ea3cc3a0d08$var$S = null, $cd9c3ea3cc3a0d08$var$yb = $eUqFw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $cd9c3ea3cc3a0d08$var$zb(a) {
    console.error(a);
    return null;
}
function $cd9c3ea3cc3a0d08$var$T() {}
function $cd9c3ea3cc3a0d08$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $cd9c3ea3cc3a0d08$var$zb : f,
        onAllReady: void 0 === e ? $cd9c3ea3cc3a0d08$var$T : e,
        onShellReady: void 0 === g ? $cd9c3ea3cc3a0d08$var$T : g,
        onShellError: void 0 === h ? $cd9c3ea3cc3a0d08$var$T : h,
        onFatalError: void 0 === k ? $cd9c3ea3cc3a0d08$var$T : k
    };
    c = $cd9c3ea3cc3a0d08$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $cd9c3ea3cc3a0d08$var$Bb(b, a, null, c, n, $cd9c3ea3cc3a0d08$var$Ya, null, $cd9c3ea3cc3a0d08$var$fb);
    m.push(a);
    return b;
}
function $cd9c3ea3cc3a0d08$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $cd9c3ea3cc3a0d08$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $cd9c3ea3cc3a0d08$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $cd9c3ea3cc3a0d08$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $cd9c3ea3cc3a0d08$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $cd9c3ea3cc3a0d08$var$Db(a, b, c, d, f) {
    $cd9c3ea3cc3a0d08$var$I = {};
    $cd9c3ea3cc3a0d08$var$ob = b;
    $cd9c3ea3cc3a0d08$var$N = 0;
    for(a = c(d, f); $cd9c3ea3cc3a0d08$var$M;)$cd9c3ea3cc3a0d08$var$M = !1, $cd9c3ea3cc3a0d08$var$N = 0, $cd9c3ea3cc3a0d08$var$P += 1, $cd9c3ea3cc3a0d08$var$K = null, a = c(d, f);
    $cd9c3ea3cc3a0d08$var$rb();
    return a;
}
function $cd9c3ea3cc3a0d08$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($cd9c3ea3cc3a0d08$var$l(108, $cd9c3ea3cc3a0d08$var$Xa(d) || "Unknown", h));
            d = $cd9c3ea3cc3a0d08$var$B({}, g, c);
        }
        b.legacyContext = d;
        $cd9c3ea3cc3a0d08$var$X(a, b, f);
        b.legacyContext = g;
    } else $cd9c3ea3cc3a0d08$var$X(a, b, f);
}
function $cd9c3ea3cc3a0d08$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $cd9c3ea3cc3a0d08$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $cd9c3ea3cc3a0d08$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $cd9c3ea3cc3a0d08$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $cd9c3ea3cc3a0d08$var$eb(e, c, d, f);
            $cd9c3ea3cc3a0d08$var$Eb(a, b, e, c);
        } else {
            e = $cd9c3ea3cc3a0d08$var$Za(c, b.legacyContext);
            f = $cd9c3ea3cc3a0d08$var$Db(a, b, c, d, e);
            var g = 0 !== $cd9c3ea3cc3a0d08$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $cd9c3ea3cc3a0d08$var$eb(f, c, d, e), $cd9c3ea3cc3a0d08$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $cd9c3ea3cc3a0d08$var$gb(d, 1, 0);
                try {
                    $cd9c3ea3cc3a0d08$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $cd9c3ea3cc3a0d08$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $cd9c3ea3cc3a0d08$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $cd9c3ea3cc3a0d08$var$ra(g, c, d);
        $cd9c3ea3cc3a0d08$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $cd9c3ea3cc3a0d08$var$Ua:
            case $cd9c3ea3cc3a0d08$var$Ta:
            case $cd9c3ea3cc3a0d08$var$Ja:
            case $cd9c3ea3cc3a0d08$var$Ka:
            case $cd9c3ea3cc3a0d08$var$Ia:
                $cd9c3ea3cc3a0d08$var$X(a, b, d.children);
                return;
            case $cd9c3ea3cc3a0d08$var$Pa:
                $cd9c3ea3cc3a0d08$var$X(a, b, d.children);
                return;
            case $cd9c3ea3cc3a0d08$var$Sa:
                throw Error($cd9c3ea3cc3a0d08$var$l(343));
            case $cd9c3ea3cc3a0d08$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $cd9c3ea3cc3a0d08$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $cd9c3ea3cc3a0d08$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($cd9c3ea3cc3a0d08$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $cd9c3ea3cc3a0d08$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $cd9c3ea3cc3a0d08$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $cd9c3ea3cc3a0d08$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $cd9c3ea3cc3a0d08$var$Na:
                d = $cd9c3ea3cc3a0d08$var$Db(a, b, c.render, d, f);
                if (0 !== $cd9c3ea3cc3a0d08$var$N) {
                    c = b.treeContext;
                    b.treeContext = $cd9c3ea3cc3a0d08$var$gb(c, 1, 0);
                    try {
                        $cd9c3ea3cc3a0d08$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $cd9c3ea3cc3a0d08$var$X(a, b, d);
                return;
            case $cd9c3ea3cc3a0d08$var$Qa:
                c = c.type;
                d = $cd9c3ea3cc3a0d08$var$Fb(c, d);
                $cd9c3ea3cc3a0d08$var$Gb(a, b, c, d, f);
                return;
            case $cd9c3ea3cc3a0d08$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $cd9c3ea3cc3a0d08$var$E;
                $cd9c3ea3cc3a0d08$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $cd9c3ea3cc3a0d08$var$X(a, b, f);
                a = $cd9c3ea3cc3a0d08$var$E;
                if (null === a) throw Error($cd9c3ea3cc3a0d08$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $cd9c3ea3cc3a0d08$var$Va ? a.context._defaultValue : d;
                a = $cd9c3ea3cc3a0d08$var$E = a.parent;
                b.context = a;
                return;
            case $cd9c3ea3cc3a0d08$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $cd9c3ea3cc3a0d08$var$X(a, b, d);
                return;
            case $cd9c3ea3cc3a0d08$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $cd9c3ea3cc3a0d08$var$Fb(c, d);
                $cd9c3ea3cc3a0d08$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($cd9c3ea3cc3a0d08$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $cd9c3ea3cc3a0d08$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $cd9c3ea3cc3a0d08$var$Ga:
                $cd9c3ea3cc3a0d08$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $cd9c3ea3cc3a0d08$var$Ha:
                throw Error($cd9c3ea3cc3a0d08$var$l(257));
            case $cd9c3ea3cc3a0d08$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $cd9c3ea3cc3a0d08$var$X(a, b, c);
                return;
        }
        if ($cd9c3ea3cc3a0d08$var$qa(c)) {
            $cd9c3ea3cc3a0d08$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $cd9c3ea3cc3a0d08$var$Wa && c[$cd9c3ea3cc3a0d08$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $cd9c3ea3cc3a0d08$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($cd9c3ea3cc3a0d08$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $cd9c3ea3cc3a0d08$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $cd9c3ea3cc3a0d08$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $cd9c3ea3cc3a0d08$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $cd9c3ea3cc3a0d08$var$gb(e, d, f);
        try {
            $cd9c3ea3cc3a0d08$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $cd9c3ea3cc3a0d08$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $cd9c3ea3cc3a0d08$var$X(a, b, c);
    } catch (k) {
        if ($cd9c3ea3cc3a0d08$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $cd9c3ea3cc3a0d08$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $cd9c3ea3cc3a0d08$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $cd9c3ea3cc3a0d08$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $cd9c3ea3cc3a0d08$var$G(e), k;
    }
}
function $cd9c3ea3cc3a0d08$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $cd9c3ea3cc3a0d08$var$Kb(this, b, a);
}
function $cd9c3ea3cc3a0d08$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($cd9c3ea3cc3a0d08$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $cd9c3ea3cc3a0d08$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $cd9c3ea3cc3a0d08$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $cd9c3ea3cc3a0d08$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $cd9c3ea3cc3a0d08$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($cd9c3ea3cc3a0d08$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $cd9c3ea3cc3a0d08$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $cd9c3ea3cc3a0d08$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($cd9c3ea3cc3a0d08$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($cd9c3ea3cc3a0d08$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $cd9c3ea3cc3a0d08$var$Cb(a) {
    if (2 !== a.status) {
        var b = $cd9c3ea3cc3a0d08$var$E, c = $cd9c3ea3cc3a0d08$var$yb.current;
        $cd9c3ea3cc3a0d08$var$yb.current = $cd9c3ea3cc3a0d08$var$xb;
        var d = $cd9c3ea3cc3a0d08$var$S;
        $cd9c3ea3cc3a0d08$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $cd9c3ea3cc3a0d08$var$G(g.context);
                    try {
                        $cd9c3ea3cc3a0d08$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $cd9c3ea3cc3a0d08$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($cd9c3ea3cc3a0d08$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $cd9c3ea3cc3a0d08$var$V(h, q);
                            null === n ? $cd9c3ea3cc3a0d08$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $cd9c3ea3cc3a0d08$var$Mb(a, a.destination);
        } catch (z) {
            $cd9c3ea3cc3a0d08$var$V(a, z), $cd9c3ea3cc3a0d08$var$W(a, z);
        } finally{
            $cd9c3ea3cc3a0d08$var$S = d, $cd9c3ea3cc3a0d08$var$yb.current = c, c === $cd9c3ea3cc3a0d08$var$xb && $cd9c3ea3cc3a0d08$var$G(b);
        }
    }
}
function $cd9c3ea3cc3a0d08$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $cd9c3ea3cc3a0d08$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($cd9c3ea3cc3a0d08$var$l(390));
    }
}
function $cd9c3ea3cc3a0d08$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $cd9c3ea3cc3a0d08$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $cd9c3ea3cc3a0d08$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $cd9c3ea3cc3a0d08$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $cd9c3ea3cc3a0d08$var$za(b, a.responseState, d);
        $cd9c3ea3cc3a0d08$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $cd9c3ea3cc3a0d08$var$za(b, a.responseState, d.id), $cd9c3ea3cc3a0d08$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($cd9c3ea3cc3a0d08$var$l(391));
    $cd9c3ea3cc3a0d08$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $cd9c3ea3cc3a0d08$var$Ob(a, b, c) {
    $cd9c3ea3cc3a0d08$var$Aa(b, a.responseState, c.formatContext, c.id);
    $cd9c3ea3cc3a0d08$var$Nb(a, b, c);
    return $cd9c3ea3cc3a0d08$var$Ba(b, c.formatContext);
}
function $cd9c3ea3cc3a0d08$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$cd9c3ea3cc3a0d08$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($cd9c3ea3cc3a0d08$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $cd9c3ea3cc3a0d08$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($cd9c3ea3cc3a0d08$var$l(392));
        return $cd9c3ea3cc3a0d08$var$Ob(a, b, d);
    }
    $cd9c3ea3cc3a0d08$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $cd9c3ea3cc3a0d08$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $cd9c3ea3cc3a0d08$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($cd9c3ea3cc3a0d08$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $cd9c3ea3cc3a0d08$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $cd9c3ea3cc3a0d08$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $cd9c3ea3cc3a0d08$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$cd9c3ea3cc3a0d08$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$cd9c3ea3cc3a0d08$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$cd9c3ea3cc3a0d08$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $cd9c3ea3cc3a0d08$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $cd9c3ea3cc3a0d08$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $cd9c3ea3cc3a0d08$var$Mb(a, a.destination);
    } catch (d) {
        $cd9c3ea3cc3a0d08$var$V(a, d), $cd9c3ea3cc3a0d08$var$W(a, d);
    }
}
function $cd9c3ea3cc3a0d08$var$Sb() {}
function $cd9c3ea3cc3a0d08$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $cd9c3ea3cc3a0d08$var$Ab(a, $cd9c3ea3cc3a0d08$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $cd9c3ea3cc3a0d08$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $cd9c3ea3cc3a0d08$var$Cb(a);
    $cd9c3ea3cc3a0d08$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $cd9c3ea3cc3a0d08$var$Mb(a, h);
        } catch (m) {
            $cd9c3ea3cc3a0d08$var$V(a, m), $cd9c3ea3cc3a0d08$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($cd9c3ea3cc3a0d08$var$l(426));
    return g;
}
$cd9c3ea3cc3a0d08$export$307591e98609eddd = function() {
    throw Error($cd9c3ea3cc3a0d08$var$l(207));
};
$cd9c3ea3cc3a0d08$export$eb3a06aef9e6ee51 = function(a, b) {
    return $cd9c3ea3cc3a0d08$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$cd9c3ea3cc3a0d08$export$b23711c915539651 = function() {
    throw Error($cd9c3ea3cc3a0d08$var$l(208));
};
$cd9c3ea3cc3a0d08$export$80e7718417253a51 = function(a, b) {
    return $cd9c3ea3cc3a0d08$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$cd9c3ea3cc3a0d08$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("j9HRh", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $df20e0f478e77972$export$7020a3240b287705, (v) => $df20e0f478e77972$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $df20e0f478e77972$export$83d89fbfd8236492, (v) => $df20e0f478e77972$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $df20e0f478e77972$export$7020a3240b287705;
var $df20e0f478e77972$export$83d89fbfd8236492;
'use strict';

var $eUqFw = parcelRequire("eUqFw");
function $df20e0f478e77972$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $df20e0f478e77972$var$l = null, $df20e0f478e77972$var$n = 0;
function $df20e0f478e77972$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $df20e0f478e77972$var$n && (a.enqueue(new Uint8Array($df20e0f478e77972$var$l.buffer, 0, $df20e0f478e77972$var$n)), $df20e0f478e77972$var$l = new Uint8Array(512), $df20e0f478e77972$var$n = 0), a.enqueue(b);
        else {
            var c = $df20e0f478e77972$var$l.length - $df20e0f478e77972$var$n;
            c < b.length && (0 === c ? a.enqueue($df20e0f478e77972$var$l) : ($df20e0f478e77972$var$l.set(b.subarray(0, c), $df20e0f478e77972$var$n), a.enqueue($df20e0f478e77972$var$l), b = b.subarray(c)), $df20e0f478e77972$var$l = new Uint8Array(512), $df20e0f478e77972$var$n = 0);
            $df20e0f478e77972$var$l.set(b, $df20e0f478e77972$var$n);
            $df20e0f478e77972$var$n += b.length;
        }
    }
}
function $df20e0f478e77972$var$t(a, b) {
    $df20e0f478e77972$var$p(a, b);
    return !0;
}
function $df20e0f478e77972$var$ba(a) {
    $df20e0f478e77972$var$l && 0 < $df20e0f478e77972$var$n && (a.enqueue(new Uint8Array($df20e0f478e77972$var$l.buffer, 0, $df20e0f478e77972$var$n)), $df20e0f478e77972$var$l = null, $df20e0f478e77972$var$n = 0);
}
var $df20e0f478e77972$var$ca = new TextEncoder;
function $df20e0f478e77972$var$u(a) {
    return $df20e0f478e77972$var$ca.encode(a);
}
function $df20e0f478e77972$var$w(a) {
    return $df20e0f478e77972$var$ca.encode(a);
}
function $df20e0f478e77972$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $df20e0f478e77972$var$x = Object.prototype.hasOwnProperty, $df20e0f478e77972$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $df20e0f478e77972$var$fa = {}, $df20e0f478e77972$var$ha = {};
function $df20e0f478e77972$var$ia(a) {
    if ($df20e0f478e77972$var$x.call($df20e0f478e77972$var$ha, a)) return !0;
    if ($df20e0f478e77972$var$x.call($df20e0f478e77972$var$fa, a)) return !1;
    if ($df20e0f478e77972$var$ea.test(a)) return $df20e0f478e77972$var$ha[a] = !0;
    $df20e0f478e77972$var$fa[a] = !0;
    return !1;
}
function $df20e0f478e77972$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $df20e0f478e77972$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $df20e0f478e77972$var$z[b] = new $df20e0f478e77972$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $df20e0f478e77972$var$ja = /[\-:]([a-z])/g;
function $df20e0f478e77972$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($df20e0f478e77972$var$ja, $df20e0f478e77972$var$ka);
    $df20e0f478e77972$var$z[b] = new $df20e0f478e77972$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($df20e0f478e77972$var$ja, $df20e0f478e77972$var$ka);
    $df20e0f478e77972$var$z[b] = new $df20e0f478e77972$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($df20e0f478e77972$var$ja, $df20e0f478e77972$var$ka);
    $df20e0f478e77972$var$z[b] = new $df20e0f478e77972$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$df20e0f478e77972$var$z.xlinkHref = new $df20e0f478e77972$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $df20e0f478e77972$var$z[a] = new $df20e0f478e77972$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $df20e0f478e77972$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $df20e0f478e77972$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($df20e0f478e77972$var$B).forEach(function(a) {
    $df20e0f478e77972$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $df20e0f478e77972$var$B[b] = $df20e0f478e77972$var$B[a];
    });
});
var $df20e0f478e77972$var$oa = /["'&<>]/;
function $df20e0f478e77972$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $df20e0f478e77972$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $df20e0f478e77972$var$pa = /([A-Z])/g, $df20e0f478e77972$var$qa = /^ms-/, $df20e0f478e77972$var$ra = Array.isArray, $df20e0f478e77972$var$sa = $df20e0f478e77972$var$w("<script>"), $df20e0f478e77972$var$ta = $df20e0f478e77972$var$w("\x3c/script>"), $df20e0f478e77972$var$ua = $df20e0f478e77972$var$w('<script src="'), $df20e0f478e77972$var$va = $df20e0f478e77972$var$w('<script type="module" src="'), $df20e0f478e77972$var$wa = $df20e0f478e77972$var$w('" async="">\x3c/script>'), $df20e0f478e77972$var$xa = /(<\/|<)(s)(cript)/gi;
function $df20e0f478e77972$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $df20e0f478e77972$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $df20e0f478e77972$var$sa : $df20e0f478e77972$var$w('<script nonce="' + $df20e0f478e77972$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $df20e0f478e77972$var$u(("" + c).replace($df20e0f478e77972$var$xa, $df20e0f478e77972$var$ya)), $df20e0f478e77972$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($df20e0f478e77972$var$ua, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d[c])), $df20e0f478e77972$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($df20e0f478e77972$var$va, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(f[d])), $df20e0f478e77972$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $df20e0f478e77972$var$w(a + "P:"),
        segmentPrefix: $df20e0f478e77972$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $df20e0f478e77972$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $df20e0f478e77972$var$Aa(a) {
    return $df20e0f478e77972$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $df20e0f478e77972$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $df20e0f478e77972$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $df20e0f478e77972$var$D(2, null);
        case "math":
            return $df20e0f478e77972$var$D(3, null);
        case "foreignObject":
            return $df20e0f478e77972$var$D(1, null);
        case "table":
            return $df20e0f478e77972$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $df20e0f478e77972$var$D(5, null);
        case "colgroup":
            return $df20e0f478e77972$var$D(7, null);
        case "tr":
            return $df20e0f478e77972$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $df20e0f478e77972$var$D(1, null) : a;
}
var $df20e0f478e77972$var$Ca = $df20e0f478e77972$var$w("\x3c!-- --\x3e");
function $df20e0f478e77972$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($df20e0f478e77972$var$Ca);
    a.push($df20e0f478e77972$var$u($df20e0f478e77972$var$C(b)));
    return !0;
}
var $df20e0f478e77972$var$Ea = new Map, $df20e0f478e77972$var$Fa = $df20e0f478e77972$var$w(' style="'), $df20e0f478e77972$var$Ga = $df20e0f478e77972$var$w(":"), $df20e0f478e77972$var$Ha = $df20e0f478e77972$var$w(";");
function $df20e0f478e77972$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($df20e0f478e77972$var$k(62));
    b = !0;
    for(var d in c)if ($df20e0f478e77972$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d));
                f = $df20e0f478e77972$var$u($df20e0f478e77972$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $df20e0f478e77972$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $df20e0f478e77972$var$w($df20e0f478e77972$var$C(e.replace($df20e0f478e77972$var$pa, "-$1").toLowerCase().replace($df20e0f478e77972$var$qa, "-ms-"))), $df20e0f478e77972$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $df20e0f478e77972$var$x.call($df20e0f478e77972$var$B, d) ? $df20e0f478e77972$var$u("" + f) : $df20e0f478e77972$var$u(f + "px") : $df20e0f478e77972$var$u($df20e0f478e77972$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($df20e0f478e77972$var$Fa, e, $df20e0f478e77972$var$Ga, f)) : a.push($df20e0f478e77972$var$Ha, e, $df20e0f478e77972$var$Ga, f);
        }
    }
    b || a.push($df20e0f478e77972$var$E);
}
var $df20e0f478e77972$var$H = $df20e0f478e77972$var$w(" "), $df20e0f478e77972$var$I = $df20e0f478e77972$var$w('="'), $df20e0f478e77972$var$E = $df20e0f478e77972$var$w('"'), $df20e0f478e77972$var$Ja = $df20e0f478e77972$var$w('=""');
function $df20e0f478e77972$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $df20e0f478e77972$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $df20e0f478e77972$var$z.hasOwnProperty(c) ? $df20e0f478e77972$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $df20e0f478e77972$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($df20e0f478e77972$var$H, c, $df20e0f478e77972$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($df20e0f478e77972$var$H, c, $df20e0f478e77972$var$Ja) : !1 !== d && a.push($df20e0f478e77972$var$H, c, $df20e0f478e77972$var$I, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d)), $df20e0f478e77972$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($df20e0f478e77972$var$H, c, $df20e0f478e77972$var$I, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d)), $df20e0f478e77972$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($df20e0f478e77972$var$H, c, $df20e0f478e77972$var$I, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d)), $df20e0f478e77972$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($df20e0f478e77972$var$H, c, $df20e0f478e77972$var$I, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d)), $df20e0f478e77972$var$E);
            }
        } else if ($df20e0f478e77972$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($df20e0f478e77972$var$H, $df20e0f478e77972$var$u(c), $df20e0f478e77972$var$I, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d)), $df20e0f478e77972$var$E);
        }
    }
}
var $df20e0f478e77972$var$K = $df20e0f478e77972$var$w(">"), $df20e0f478e77972$var$Ka = $df20e0f478e77972$var$w("/>");
function $df20e0f478e77972$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($df20e0f478e77972$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($df20e0f478e77972$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($df20e0f478e77972$var$u("" + b));
    }
}
function $df20e0f478e77972$var$La(a) {
    var b = "";
    $eUqFw.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $df20e0f478e77972$var$Ma = $df20e0f478e77972$var$w(' selected=""');
function $df20e0f478e77972$var$Na(a, b, c, d) {
    a.push($df20e0f478e77972$var$M(c));
    var f = c = null, e;
    for(e in b)if ($df20e0f478e77972$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $df20e0f478e77972$var$J(a, d, e, g);
        }
    }
    a.push($df20e0f478e77972$var$K);
    $df20e0f478e77972$var$L(a, f, c);
    return "string" === typeof c ? (a.push($df20e0f478e77972$var$u($df20e0f478e77972$var$C(c))), null) : c;
}
var $df20e0f478e77972$var$Oa = $df20e0f478e77972$var$w("\n"), $df20e0f478e77972$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $df20e0f478e77972$var$Qa = new Map;
function $df20e0f478e77972$var$M(a) {
    var b = $df20e0f478e77972$var$Qa.get(a);
    if (void 0 === b) {
        if (!$df20e0f478e77972$var$Pa.test(a)) throw Error($df20e0f478e77972$var$k(65, a));
        b = $df20e0f478e77972$var$w("<" + a);
        $df20e0f478e77972$var$Qa.set(a, b);
    }
    return b;
}
var $df20e0f478e77972$var$Ra = $df20e0f478e77972$var$w("<!DOCTYPE html>");
function $df20e0f478e77972$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($df20e0f478e77972$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($df20e0f478e77972$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $df20e0f478e77972$var$J(a, d, r, h);
                }
            }
            a.push($df20e0f478e77972$var$K);
            $df20e0f478e77972$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($df20e0f478e77972$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($df20e0f478e77972$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $df20e0f478e77972$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $df20e0f478e77972$var$La(h), $df20e0f478e77972$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($df20e0f478e77972$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($df20e0f478e77972$var$Ma);
            } else q && a.push($df20e0f478e77972$var$Ma);
            a.push($df20e0f478e77972$var$K);
            $df20e0f478e77972$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($df20e0f478e77972$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($df20e0f478e77972$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($df20e0f478e77972$var$k(91));
                default:
                    $df20e0f478e77972$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($df20e0f478e77972$var$K);
            if (null != r) {
                if (null != e) throw Error($df20e0f478e77972$var$k(92));
                if ($df20e0f478e77972$var$ra(r) && 1 < r.length) throw Error($df20e0f478e77972$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($df20e0f478e77972$var$Oa);
            null !== e && a.push($df20e0f478e77972$var$u($df20e0f478e77972$var$C("" + e)));
            return null;
        case "input":
            a.push($df20e0f478e77972$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($df20e0f478e77972$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($df20e0f478e77972$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $df20e0f478e77972$var$J(a, d, g, q);
            }
            null !== r ? $df20e0f478e77972$var$J(a, d, "checked", r) : null !== m && $df20e0f478e77972$var$J(a, d, "checked", m);
            null !== e ? $df20e0f478e77972$var$J(a, d, "value", e) : null !== h && $df20e0f478e77972$var$J(a, d, "value", h);
            a.push($df20e0f478e77972$var$Ka);
            return null;
        case "menuitem":
            a.push($df20e0f478e77972$var$M("menuitem"));
            for(var A in c)if ($df20e0f478e77972$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($df20e0f478e77972$var$k(400));
                default:
                    $df20e0f478e77972$var$J(a, d, A, e);
            }
            a.push($df20e0f478e77972$var$K);
            return null;
        case "title":
            a.push($df20e0f478e77972$var$M("title"));
            e = null;
            for(v in c)if ($df20e0f478e77972$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($df20e0f478e77972$var$k(434));
                default:
                    $df20e0f478e77972$var$J(a, d, v, g);
            }
            a.push($df20e0f478e77972$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($df20e0f478e77972$var$M(b));
            g = e = null;
            for(m in c)if ($df20e0f478e77972$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $df20e0f478e77972$var$J(a, d, m, h);
            }
            a.push($df20e0f478e77972$var$K);
            if (null != g) {
                if (null != e) throw Error($df20e0f478e77972$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($df20e0f478e77972$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($df20e0f478e77972$var$Oa, $df20e0f478e77972$var$u(c)) : a.push($df20e0f478e77972$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($df20e0f478e77972$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($df20e0f478e77972$var$M(b));
            for(var F in c)if ($df20e0f478e77972$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($df20e0f478e77972$var$k(399, b));
                default:
                    $df20e0f478e77972$var$J(a, d, F, e);
            }
            a.push($df20e0f478e77972$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $df20e0f478e77972$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($df20e0f478e77972$var$Ra), $df20e0f478e77972$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $df20e0f478e77972$var$Na(a, c, b, d);
            a.push($df20e0f478e77972$var$M(b));
            g = e = null;
            for(q in c)if ($df20e0f478e77972$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $df20e0f478e77972$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $df20e0f478e77972$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($df20e0f478e77972$var$H, $df20e0f478e77972$var$u(q), $df20e0f478e77972$var$I, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(h)), $df20e0f478e77972$var$E);
            }
            a.push($df20e0f478e77972$var$K);
            $df20e0f478e77972$var$L(a, g, e);
            return e;
    }
}
var $df20e0f478e77972$var$Ta = $df20e0f478e77972$var$w("</"), $df20e0f478e77972$var$Ua = $df20e0f478e77972$var$w(">"), $df20e0f478e77972$var$Va = $df20e0f478e77972$var$w('<template id="'), $df20e0f478e77972$var$Wa = $df20e0f478e77972$var$w('"></template>'), $df20e0f478e77972$var$Xa = $df20e0f478e77972$var$w("\x3c!--$--\x3e"), $df20e0f478e77972$var$Ya = $df20e0f478e77972$var$w('\x3c!--$?--\x3e<template id="'), $df20e0f478e77972$var$Za = $df20e0f478e77972$var$w('"></template>'), $df20e0f478e77972$var$$a = $df20e0f478e77972$var$w("\x3c!--$!--\x3e"), $df20e0f478e77972$var$ab = $df20e0f478e77972$var$w("\x3c!--/$--\x3e"), $df20e0f478e77972$var$bb = $df20e0f478e77972$var$w("<template"), $df20e0f478e77972$var$cb = $df20e0f478e77972$var$w('"'), $df20e0f478e77972$var$db = $df20e0f478e77972$var$w(' data-dgst="');
$df20e0f478e77972$var$w(' data-msg="');
$df20e0f478e77972$var$w(' data-stck="');
var $df20e0f478e77972$var$eb = $df20e0f478e77972$var$w("></template>");
function $df20e0f478e77972$var$fb(a, b, c) {
    $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$Ya);
    if (null === c) throw Error($df20e0f478e77972$var$k(395));
    $df20e0f478e77972$var$p(a, c);
    return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$Za);
}
var $df20e0f478e77972$var$gb = $df20e0f478e77972$var$w('<div hidden id="'), $df20e0f478e77972$var$hb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$ib = $df20e0f478e77972$var$w("</div>"), $df20e0f478e77972$var$jb = $df20e0f478e77972$var$w('<svg aria-hidden="true" style="display:none" id="'), $df20e0f478e77972$var$kb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$lb = $df20e0f478e77972$var$w("</svg>"), $df20e0f478e77972$var$mb = $df20e0f478e77972$var$w('<math aria-hidden="true" style="display:none" id="'), $df20e0f478e77972$var$nb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$ob = $df20e0f478e77972$var$w("</math>"), $df20e0f478e77972$var$pb = $df20e0f478e77972$var$w('<table hidden id="'), $df20e0f478e77972$var$qb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$rb = $df20e0f478e77972$var$w("</table>"), $df20e0f478e77972$var$sb = $df20e0f478e77972$var$w('<table hidden><tbody id="'), $df20e0f478e77972$var$tb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$ub = $df20e0f478e77972$var$w("</tbody></table>"), $df20e0f478e77972$var$vb = $df20e0f478e77972$var$w('<table hidden><tr id="'), $df20e0f478e77972$var$wb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$xb = $df20e0f478e77972$var$w("</tr></table>"), $df20e0f478e77972$var$yb = $df20e0f478e77972$var$w('<table hidden><colgroup id="'), $df20e0f478e77972$var$zb = $df20e0f478e77972$var$w('">'), $df20e0f478e77972$var$Ab = $df20e0f478e77972$var$w("</colgroup></table>");
function $df20e0f478e77972$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$gb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$hb);
        case 2:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$jb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$kb);
        case 3:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$mb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$nb);
        case 4:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$pb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$qb);
        case 5:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$sb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$tb);
        case 6:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$vb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$wb);
        case 7:
            return $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$yb), $df20e0f478e77972$var$p(a, b.segmentPrefix), $df20e0f478e77972$var$p(a, $df20e0f478e77972$var$u(d.toString(16))), $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$zb);
        default:
            throw Error($df20e0f478e77972$var$k(397));
    }
}
function $df20e0f478e77972$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$ib);
        case 2:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$lb);
        case 3:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$ob);
        case 4:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$rb);
        case 5:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$ub);
        case 6:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$xb);
        case 7:
            return $df20e0f478e77972$var$t(a, $df20e0f478e77972$var$Ab);
        default:
            throw Error($df20e0f478e77972$var$k(397));
    }
}
var $df20e0f478e77972$var$Db = $df20e0f478e77972$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $df20e0f478e77972$var$Eb = $df20e0f478e77972$var$w('$RS("'), $df20e0f478e77972$var$Gb = $df20e0f478e77972$var$w('","'), $df20e0f478e77972$var$Hb = $df20e0f478e77972$var$w('")\x3c/script>'), $df20e0f478e77972$var$Ib = $df20e0f478e77972$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $df20e0f478e77972$var$Jb = $df20e0f478e77972$var$w('$RC("'), $df20e0f478e77972$var$Kb = $df20e0f478e77972$var$w('","'), $df20e0f478e77972$var$Lb = $df20e0f478e77972$var$w('")\x3c/script>'), $df20e0f478e77972$var$Mb = $df20e0f478e77972$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $df20e0f478e77972$var$Nb = $df20e0f478e77972$var$w('$RX("'), $df20e0f478e77972$var$Ob = $df20e0f478e77972$var$w('"'), $df20e0f478e77972$var$Pb = $df20e0f478e77972$var$w(")\x3c/script>"), $df20e0f478e77972$var$Qb = $df20e0f478e77972$var$w(","), $df20e0f478e77972$var$Rb = /[<\u2028\u2029]/g;
function $df20e0f478e77972$var$Sb(a) {
    return JSON.stringify(a).replace($df20e0f478e77972$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $df20e0f478e77972$var$N = Object.assign, $df20e0f478e77972$var$Tb = Symbol.for("react.element"), $df20e0f478e77972$var$Ub = Symbol.for("react.portal"), $df20e0f478e77972$var$Vb = Symbol.for("react.fragment"), $df20e0f478e77972$var$Wb = Symbol.for("react.strict_mode"), $df20e0f478e77972$var$Xb = Symbol.for("react.profiler"), $df20e0f478e77972$var$Yb = Symbol.for("react.provider"), $df20e0f478e77972$var$Zb = Symbol.for("react.context"), $df20e0f478e77972$var$$b = Symbol.for("react.forward_ref"), $df20e0f478e77972$var$ac = Symbol.for("react.suspense"), $df20e0f478e77972$var$bc = Symbol.for("react.suspense_list"), $df20e0f478e77972$var$cc = Symbol.for("react.memo"), $df20e0f478e77972$var$dc = Symbol.for("react.lazy"), $df20e0f478e77972$var$ec = Symbol.for("react.scope"), $df20e0f478e77972$var$fc = Symbol.for("react.debug_trace_mode"), $df20e0f478e77972$var$gc = Symbol.for("react.legacy_hidden"), $df20e0f478e77972$var$hc = Symbol.for("react.default_value"), $df20e0f478e77972$var$ic = Symbol.iterator;
function $df20e0f478e77972$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $df20e0f478e77972$var$Vb:
            return "Fragment";
        case $df20e0f478e77972$var$Ub:
            return "Portal";
        case $df20e0f478e77972$var$Xb:
            return "Profiler";
        case $df20e0f478e77972$var$Wb:
            return "StrictMode";
        case $df20e0f478e77972$var$ac:
            return "Suspense";
        case $df20e0f478e77972$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $df20e0f478e77972$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $df20e0f478e77972$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $df20e0f478e77972$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $df20e0f478e77972$var$cc:
            return b = a.displayName || null, null !== b ? b : $df20e0f478e77972$var$jc(a.type) || "Memo";
        case $df20e0f478e77972$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $df20e0f478e77972$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $df20e0f478e77972$var$kc = {};
function $df20e0f478e77972$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $df20e0f478e77972$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $df20e0f478e77972$var$O = null;
function $df20e0f478e77972$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($df20e0f478e77972$var$k(401));
        } else {
            if (null === c) throw Error($df20e0f478e77972$var$k(401));
            $df20e0f478e77972$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $df20e0f478e77972$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $df20e0f478e77972$var$mc(a);
}
function $df20e0f478e77972$var$nc(a) {
    var b = a.parent;
    null !== b && $df20e0f478e77972$var$nc(b);
    a.context._currentValue = a.value;
}
function $df20e0f478e77972$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($df20e0f478e77972$var$k(402));
    a.depth === b.depth ? $df20e0f478e77972$var$P(a, b) : $df20e0f478e77972$var$oc(a, b);
}
function $df20e0f478e77972$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($df20e0f478e77972$var$k(402));
    a.depth === c.depth ? $df20e0f478e77972$var$P(a, c) : $df20e0f478e77972$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $df20e0f478e77972$var$Q(a) {
    var b = $df20e0f478e77972$var$O;
    b !== a && (null === b ? $df20e0f478e77972$var$nc(a) : null === a ? $df20e0f478e77972$var$mc(b) : b.depth === a.depth ? $df20e0f478e77972$var$P(b, a) : b.depth > a.depth ? $df20e0f478e77972$var$oc(b, a) : $df20e0f478e77972$var$pc(b, a), $df20e0f478e77972$var$O = a);
}
var $df20e0f478e77972$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $df20e0f478e77972$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $df20e0f478e77972$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $df20e0f478e77972$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $df20e0f478e77972$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $df20e0f478e77972$var$N({}, e, h)) : $df20e0f478e77972$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $df20e0f478e77972$var$sc = {
    id: 1,
    overflow: ""
};
function $df20e0f478e77972$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $df20e0f478e77972$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $df20e0f478e77972$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $df20e0f478e77972$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $df20e0f478e77972$var$uc = Math.clz32 ? Math.clz32 : $df20e0f478e77972$var$vc, $df20e0f478e77972$var$wc = Math.log, $df20e0f478e77972$var$xc = Math.LN2;
function $df20e0f478e77972$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($df20e0f478e77972$var$wc(a) / $df20e0f478e77972$var$xc | 0) | 0;
}
function $df20e0f478e77972$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $df20e0f478e77972$var$zc = "function" === typeof Object.is ? Object.is : $df20e0f478e77972$var$yc, $df20e0f478e77972$var$R = null, $df20e0f478e77972$var$Ac = null, $df20e0f478e77972$var$Bc = null, $df20e0f478e77972$var$S = null, $df20e0f478e77972$var$T = !1, $df20e0f478e77972$var$Cc = !1, $df20e0f478e77972$var$U = 0, $df20e0f478e77972$var$V = null, $df20e0f478e77972$var$Dc = 0;
function $df20e0f478e77972$var$W() {
    if (null === $df20e0f478e77972$var$R) throw Error($df20e0f478e77972$var$k(321));
    return $df20e0f478e77972$var$R;
}
function $df20e0f478e77972$var$Ec() {
    if (0 < $df20e0f478e77972$var$Dc) throw Error($df20e0f478e77972$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $df20e0f478e77972$var$Fc() {
    null === $df20e0f478e77972$var$S ? null === $df20e0f478e77972$var$Bc ? ($df20e0f478e77972$var$T = !1, $df20e0f478e77972$var$Bc = $df20e0f478e77972$var$S = $df20e0f478e77972$var$Ec()) : ($df20e0f478e77972$var$T = !0, $df20e0f478e77972$var$S = $df20e0f478e77972$var$Bc) : null === $df20e0f478e77972$var$S.next ? ($df20e0f478e77972$var$T = !1, $df20e0f478e77972$var$S = $df20e0f478e77972$var$S.next = $df20e0f478e77972$var$Ec()) : ($df20e0f478e77972$var$T = !0, $df20e0f478e77972$var$S = $df20e0f478e77972$var$S.next);
    return $df20e0f478e77972$var$S;
}
function $df20e0f478e77972$var$Gc() {
    $df20e0f478e77972$var$Ac = $df20e0f478e77972$var$R = null;
    $df20e0f478e77972$var$Cc = !1;
    $df20e0f478e77972$var$Bc = null;
    $df20e0f478e77972$var$Dc = 0;
    $df20e0f478e77972$var$S = $df20e0f478e77972$var$V = null;
}
function $df20e0f478e77972$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $df20e0f478e77972$var$Ic(a, b, c) {
    $df20e0f478e77972$var$R = $df20e0f478e77972$var$W();
    $df20e0f478e77972$var$S = $df20e0f478e77972$var$Fc();
    if ($df20e0f478e77972$var$T) {
        var d = $df20e0f478e77972$var$S.queue;
        b = d.dispatch;
        if (null !== $df20e0f478e77972$var$V && (c = $df20e0f478e77972$var$V.get(d), void 0 !== c)) {
            $df20e0f478e77972$var$V.delete(d);
            d = $df20e0f478e77972$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $df20e0f478e77972$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $df20e0f478e77972$var$S.memoizedState,
            b
        ];
    }
    a = a === $df20e0f478e77972$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $df20e0f478e77972$var$S.memoizedState = a;
    a = $df20e0f478e77972$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $df20e0f478e77972$var$Jc.bind(null, $df20e0f478e77972$var$R, a);
    return [
        $df20e0f478e77972$var$S.memoizedState,
        a
    ];
}
function $df20e0f478e77972$var$Kc(a, b) {
    $df20e0f478e77972$var$R = $df20e0f478e77972$var$W();
    $df20e0f478e77972$var$S = $df20e0f478e77972$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $df20e0f478e77972$var$S) {
        var c = $df20e0f478e77972$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$df20e0f478e77972$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $df20e0f478e77972$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $df20e0f478e77972$var$Jc(a, b, c) {
    if (25 <= $df20e0f478e77972$var$Dc) throw Error($df20e0f478e77972$var$k(301));
    if (a === $df20e0f478e77972$var$R) {
        if ($df20e0f478e77972$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $df20e0f478e77972$var$V && ($df20e0f478e77972$var$V = new Map), c = $df20e0f478e77972$var$V.get(b), void 0 === c) $df20e0f478e77972$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $df20e0f478e77972$var$Lc() {
    throw Error($df20e0f478e77972$var$k(394));
}
function $df20e0f478e77972$var$Mc() {}
var $df20e0f478e77972$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $df20e0f478e77972$var$W();
        return a._currentValue;
    },
    useMemo: $df20e0f478e77972$var$Kc,
    useReducer: $df20e0f478e77972$var$Ic,
    useRef: function(a) {
        $df20e0f478e77972$var$R = $df20e0f478e77972$var$W();
        $df20e0f478e77972$var$S = $df20e0f478e77972$var$Fc();
        var b = $df20e0f478e77972$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $df20e0f478e77972$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $df20e0f478e77972$var$Ic($df20e0f478e77972$var$Hc, a);
    },
    useInsertionEffect: $df20e0f478e77972$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $df20e0f478e77972$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $df20e0f478e77972$var$Mc,
    useEffect: $df20e0f478e77972$var$Mc,
    useDebugValue: $df20e0f478e77972$var$Mc,
    useDeferredValue: function(a) {
        $df20e0f478e77972$var$W();
        return a;
    },
    useTransition: function() {
        $df20e0f478e77972$var$W();
        return [
            !1,
            $df20e0f478e77972$var$Lc
        ];
    },
    useId: function() {
        var a = $df20e0f478e77972$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $df20e0f478e77972$var$uc(a) - 1)).toString(32) + b;
        var c = $df20e0f478e77972$var$Nc;
        if (null === c) throw Error($df20e0f478e77972$var$k(404));
        b = $df20e0f478e77972$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $df20e0f478e77972$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($df20e0f478e77972$var$k(407));
        return c();
    }
}, $df20e0f478e77972$var$Nc = null, $df20e0f478e77972$var$Pc = $eUqFw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $df20e0f478e77972$var$Qc(a) {
    console.error(a);
    return null;
}
function $df20e0f478e77972$var$X() {}
function $df20e0f478e77972$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $df20e0f478e77972$var$Qc : f,
        onAllReady: void 0 === e ? $df20e0f478e77972$var$X : e,
        onShellReady: void 0 === g ? $df20e0f478e77972$var$X : g,
        onShellError: void 0 === h ? $df20e0f478e77972$var$X : h,
        onFatalError: void 0 === m ? $df20e0f478e77972$var$X : m
    };
    c = $df20e0f478e77972$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $df20e0f478e77972$var$Tc(b, a, null, c, r, $df20e0f478e77972$var$kc, null, $df20e0f478e77972$var$sc);
    q.push(a);
    return b;
}
function $df20e0f478e77972$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $df20e0f478e77972$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $df20e0f478e77972$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $df20e0f478e77972$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $df20e0f478e77972$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $df20e0f478e77972$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $df20e0f478e77972$var$Wc(a, b, c, d, f) {
    $df20e0f478e77972$var$R = {};
    $df20e0f478e77972$var$Ac = b;
    $df20e0f478e77972$var$U = 0;
    for(a = c(d, f); $df20e0f478e77972$var$Cc;)$df20e0f478e77972$var$Cc = !1, $df20e0f478e77972$var$U = 0, $df20e0f478e77972$var$Dc += 1, $df20e0f478e77972$var$S = null, a = c(d, f);
    $df20e0f478e77972$var$Gc();
    return a;
}
function $df20e0f478e77972$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($df20e0f478e77972$var$k(108, $df20e0f478e77972$var$jc(d) || "Unknown", h));
            d = $df20e0f478e77972$var$N({}, g, c);
        }
        b.legacyContext = d;
        $df20e0f478e77972$var$Z(a, b, f);
        b.legacyContext = g;
    } else $df20e0f478e77972$var$Z(a, b, f);
}
function $df20e0f478e77972$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $df20e0f478e77972$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $df20e0f478e77972$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $df20e0f478e77972$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $df20e0f478e77972$var$rc(e, c, d, f);
            $df20e0f478e77972$var$Xc(a, b, e, c);
        } else {
            e = $df20e0f478e77972$var$lc(c, b.legacyContext);
            f = $df20e0f478e77972$var$Wc(a, b, c, d, e);
            var g = 0 !== $df20e0f478e77972$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $df20e0f478e77972$var$rc(f, c, d, e), $df20e0f478e77972$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $df20e0f478e77972$var$tc(d, 1, 0);
                try {
                    $df20e0f478e77972$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $df20e0f478e77972$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $df20e0f478e77972$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $df20e0f478e77972$var$Ba(g, c, d);
        $df20e0f478e77972$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($df20e0f478e77972$var$Ta, $df20e0f478e77972$var$u(c), $df20e0f478e77972$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $df20e0f478e77972$var$gc:
            case $df20e0f478e77972$var$fc:
            case $df20e0f478e77972$var$Wb:
            case $df20e0f478e77972$var$Xb:
            case $df20e0f478e77972$var$Vb:
                $df20e0f478e77972$var$Z(a, b, d.children);
                return;
            case $df20e0f478e77972$var$bc:
                $df20e0f478e77972$var$Z(a, b, d.children);
                return;
            case $df20e0f478e77972$var$ec:
                throw Error($df20e0f478e77972$var$k(343));
            case $df20e0f478e77972$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $df20e0f478e77972$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $df20e0f478e77972$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($df20e0f478e77972$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($df20e0f478e77972$var$Ca), q.status = 1, $df20e0f478e77972$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $df20e0f478e77972$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $df20e0f478e77972$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $df20e0f478e77972$var$$b:
                d = $df20e0f478e77972$var$Wc(a, b, c.render, d, f);
                if (0 !== $df20e0f478e77972$var$U) {
                    c = b.treeContext;
                    b.treeContext = $df20e0f478e77972$var$tc(c, 1, 0);
                    try {
                        $df20e0f478e77972$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $df20e0f478e77972$var$Z(a, b, d);
                return;
            case $df20e0f478e77972$var$cc:
                c = c.type;
                d = $df20e0f478e77972$var$Yc(c, d);
                $df20e0f478e77972$var$Zc(a, b, c, d, f);
                return;
            case $df20e0f478e77972$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $df20e0f478e77972$var$O;
                $df20e0f478e77972$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $df20e0f478e77972$var$Z(a, b, f);
                a = $df20e0f478e77972$var$O;
                if (null === a) throw Error($df20e0f478e77972$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $df20e0f478e77972$var$hc ? a.context._defaultValue : d;
                a = $df20e0f478e77972$var$O = a.parent;
                b.context = a;
                return;
            case $df20e0f478e77972$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $df20e0f478e77972$var$Z(a, b, d);
                return;
            case $df20e0f478e77972$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $df20e0f478e77972$var$Yc(c, d);
                $df20e0f478e77972$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($df20e0f478e77972$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $df20e0f478e77972$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $df20e0f478e77972$var$Tb:
                $df20e0f478e77972$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $df20e0f478e77972$var$Ub:
                throw Error($df20e0f478e77972$var$k(257));
            case $df20e0f478e77972$var$dc:
                var d = c._init;
                c = d(c._payload);
                $df20e0f478e77972$var$Z(a, b, c);
                return;
        }
        if ($df20e0f478e77972$var$ra(c)) {
            $df20e0f478e77972$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $df20e0f478e77972$var$ic && c[$df20e0f478e77972$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $df20e0f478e77972$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($df20e0f478e77972$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $df20e0f478e77972$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $df20e0f478e77972$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $df20e0f478e77972$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $df20e0f478e77972$var$tc(e, d, f);
        try {
            $df20e0f478e77972$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $df20e0f478e77972$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $df20e0f478e77972$var$Z(a, b, c);
    } catch (m) {
        if ($df20e0f478e77972$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $df20e0f478e77972$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $df20e0f478e77972$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $df20e0f478e77972$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $df20e0f478e77972$var$Q(e), m;
    }
}
function $df20e0f478e77972$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $df20e0f478e77972$var$dd(this, b, a);
}
function $df20e0f478e77972$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($df20e0f478e77972$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $df20e0f478e77972$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $df20e0f478e77972$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $df20e0f478e77972$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $df20e0f478e77972$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($df20e0f478e77972$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $df20e0f478e77972$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $df20e0f478e77972$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($df20e0f478e77972$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($df20e0f478e77972$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $df20e0f478e77972$var$Uc(a) {
    if (2 !== a.status) {
        var b = $df20e0f478e77972$var$O, c = $df20e0f478e77972$var$Pc.current;
        $df20e0f478e77972$var$Pc.current = $df20e0f478e77972$var$Oc;
        var d = $df20e0f478e77972$var$Nc;
        $df20e0f478e77972$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $df20e0f478e77972$var$Q(g.context);
                    try {
                        $df20e0f478e77972$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($df20e0f478e77972$var$Ca), g.abortSet.delete(g), m.status = 1, $df20e0f478e77972$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($df20e0f478e77972$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $df20e0f478e77972$var$Y(h, v);
                            null === r ? $df20e0f478e77972$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $df20e0f478e77972$var$fd(a, a.destination);
        } catch (G) {
            $df20e0f478e77972$var$Y(a, G), $df20e0f478e77972$var$Vc(a, G);
        } finally{
            $df20e0f478e77972$var$Nc = d, $df20e0f478e77972$var$Pc.current = c, c === $df20e0f478e77972$var$Oc && $df20e0f478e77972$var$Q(b);
        }
    }
}
function $df20e0f478e77972$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Va);
            $df20e0f478e77972$var$p(b, a.placeholderPrefix);
            a = $df20e0f478e77972$var$u(d.toString(16));
            $df20e0f478e77972$var$p(b, a);
            return $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$df20e0f478e77972$var$p(b, d[e]);
                f = $df20e0f478e77972$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$df20e0f478e77972$var$p(b, d[e]);
            e < d.length && (f = $df20e0f478e77972$var$t(b, d[e]));
            return f;
        default:
            throw Error($df20e0f478e77972$var$k(390));
    }
}
function $df20e0f478e77972$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $df20e0f478e77972$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$$a), $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$bb), d && ($df20e0f478e77972$var$p(b, $df20e0f478e77972$var$db), $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$u($df20e0f478e77972$var$C(d))), $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$cb)), $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$eb), $df20e0f478e77972$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $df20e0f478e77972$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $df20e0f478e77972$var$fb(b, a.responseState, d);
        $df20e0f478e77972$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $df20e0f478e77972$var$fb(b, a.responseState, d.id), $df20e0f478e77972$var$gd(a, b, c);
    else {
        $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($df20e0f478e77972$var$k(391));
        $df20e0f478e77972$var$hd(a, b, c[0]);
    }
    return $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$ab);
}
function $df20e0f478e77972$var$id(a, b, c) {
    $df20e0f478e77972$var$Bb(b, a.responseState, c.formatContext, c.id);
    $df20e0f478e77972$var$hd(a, b, c);
    return $df20e0f478e77972$var$Cb(b, c.formatContext);
}
function $df20e0f478e77972$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$df20e0f478e77972$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $df20e0f478e77972$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Ib));
    if (null === d) throw Error($df20e0f478e77972$var$k(395));
    c = $df20e0f478e77972$var$u(c.toString(16));
    $df20e0f478e77972$var$p(b, d);
    $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Kb);
    $df20e0f478e77972$var$p(b, a.segmentPrefix);
    $df20e0f478e77972$var$p(b, c);
    return $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$Lb);
}
function $df20e0f478e77972$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($df20e0f478e77972$var$k(392));
        return $df20e0f478e77972$var$id(a, b, d);
    }
    $df20e0f478e77972$var$id(a, b, d);
    a = a.responseState;
    $df20e0f478e77972$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Eb) : (a.sentCompleteSegmentFunction = !0, $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Db));
    $df20e0f478e77972$var$p(b, a.segmentPrefix);
    f = $df20e0f478e77972$var$u(f.toString(16));
    $df20e0f478e77972$var$p(b, f);
    $df20e0f478e77972$var$p(b, $df20e0f478e77972$var$Gb);
    $df20e0f478e77972$var$p(b, a.placeholderPrefix);
    $df20e0f478e77972$var$p(b, f);
    return $df20e0f478e77972$var$t(b, $df20e0f478e77972$var$Hb);
}
function $df20e0f478e77972$var$fd(a, b) {
    $df20e0f478e77972$var$l = new Uint8Array(512);
    $df20e0f478e77972$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $df20e0f478e77972$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$df20e0f478e77972$var$p(b, d[c]);
            c < d.length && $df20e0f478e77972$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $df20e0f478e77972$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$Nb) : (h.sentClientRenderFunction = !0, $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$Mb));
            if (null === m) throw Error($df20e0f478e77972$var$k(395));
            $df20e0f478e77972$var$p(d, m);
            $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$Ob);
            if (q || r || v) $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$Qb), $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$u($df20e0f478e77972$var$Sb(q || "")));
            if (r || v) $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$Qb), $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$u($df20e0f478e77972$var$Sb(r || "")));
            v && ($df20e0f478e77972$var$p(d, $df20e0f478e77972$var$Qb), $df20e0f478e77972$var$p(d, $df20e0f478e77972$var$u($df20e0f478e77972$var$Sb(v))));
            if (!$df20e0f478e77972$var$t(d, $df20e0f478e77972$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$df20e0f478e77972$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $df20e0f478e77972$var$ba(b);
        $df20e0f478e77972$var$l = new Uint8Array(512);
        $df20e0f478e77972$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$df20e0f478e77972$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$df20e0f478e77972$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $df20e0f478e77972$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $df20e0f478e77972$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $df20e0f478e77972$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $df20e0f478e77972$var$fd(a, a.destination);
    } catch (d) {
        $df20e0f478e77972$var$Y(a, d), $df20e0f478e77972$var$Vc(a, d);
    }
}
$df20e0f478e77972$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $df20e0f478e77972$var$Rc(a, $df20e0f478e77972$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $df20e0f478e77972$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $df20e0f478e77972$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $df20e0f478e77972$var$fd(h, a);
                        } catch (A) {
                            $df20e0f478e77972$var$Y(h, A), $df20e0f478e77972$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $df20e0f478e77972$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $df20e0f478e77972$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $df20e0f478e77972$var$Uc(h);
    });
};
$df20e0f478e77972$export$83d89fbfd8236492 = "18.2.0";

});


parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("cO5lu", function(module, exports) {

$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $c93f861423d090ca$export$99df83ca0f45bd54);

var $epRiJ = parcelRequire("epRiJ");
const $c93f861423d090ca$export$99df83ca0f45bd54 = [
    (0, $epRiJ.PreferenceCategory).Analytics,
    (0, $epRiJ.PreferenceCategory).Functional,
    (0, $epRiJ.PreferenceCategory).Marketing,
    (0, $epRiJ.PreferenceCategory).StrictlyNecessary,
    (0, $epRiJ.PreferenceCategory).Unknown
];

});

parcelRegister("25WOM", function(module, exports) {

$parcel$export(module.exports, "CookieCategorySection", () => $0e0f0fdaf1a23652$export$3c97a3b492e10ae9);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");

var $1J3ZG = parcelRequire("1J3ZG");

var $epRiJ = parcelRequire("epRiJ");
const $0e0f0fdaf1a23652$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $0e0f0fdaf1a23652$var$categoryBoxStyles = (0, $1ZAYh.xcss)({
    paddingBlockStart: 'space.200'
});
const $0e0f0fdaf1a23652$var$categoryDescriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $4lTFP.headingSizes).h200.size}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: `${(0, $4lTFP.headingSizes).h200.lineHeight}px`
});
// We don't bother tracking unknown checkbox toggles
const $0e0f0fdaf1a23652$var$categoryToEventSubjectMap = {
    [(0, $epRiJ.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $epRiJ.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $epRiJ.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $epRiJ.PreferenceCategory).Unknown]: null
};
const $0e0f0fdaf1a23652$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferences: setPreferences })=>{
    const onCheckboxChange = (0, $eUqFw.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $epRiJ.PreferenceCategory).StrictlyNecessary) return;
        setPreferences((prevPreferences)=>{
            const isSelected = !prevPreferences[category];
            const actionSubjectId = $0e0f0fdaf1a23652$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $1J3ZG.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPreferences,
                [category]: isSelected
            };
        });
    }, [
        category,
        setPreferences
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0e0f0fdaf1a23652$var$categoryBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${$0e0f0fdaf1a23652$var$tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0e0f0fdaf1a23652$var$categoryDescriptionStyles
    }, descriptionElement));
};

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});



parcelRegister("chqoM", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $282b5872a9a6b7b9$export$a7357cdd1f0b0168);

var $90IgZ = parcelRequire("90IgZ");
const $282b5872a9a6b7b9$export$a7357cdd1f0b0168 = (0, $90IgZ.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'Cookie preferences modal dialog title.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.082624',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    }
});

});



parcelRegister("aYdDB", function(module, exports) {

$parcel$export(module.exports, "PresentationalConsentBanner", () => $40d5ef4f1c4d0230$export$dd3e60478510f81d);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7u4fN = parcelRequire("7u4fN");

var $9nt1B = parcelRequire("9nt1B");

var $4kMup = parcelRequire("4kMup");
var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ywu9 = parcelRequire("4Ywu9");

var $cO5lu = parcelRequire("cO5lu");

var $gyZqn = parcelRequire("gyZqn");
const $40d5ef4f1c4d0230$var$boxStylesBlue = (0, $1ZAYh.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.accent.blue.subtlest',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden'
});
const $40d5ef4f1c4d0230$var$inlineWrapperStyles = (0, $1ZAYh.xcss)({
    // Small viewport defaults
    gap: 'space.200',
    alignItems: 'flex-start',
    flexDirection: 'column',
    // Larger viewports
    [(0, $4Ywu9.media).above.sm]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $40d5ef4f1c4d0230$var$noticeContainerStyles = (0, $1ZAYh.xcss)({
    flexDirection: 'column'
});
const $40d5ef4f1c4d0230$var$buttonContainerStyles = (0, $1ZAYh.xcss)({
    // Prevents the button text from truncating when the screen width decreases
    minWidth: 'fit-content',
    // Applies to below sm size
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $4Ywu9.media).above.sm]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $40d5ef4f1c4d0230$var$noop = ()=>{};
const $40d5ef4f1c4d0230$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $cO5lu.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $gyZqn.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $gyZqn.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $40d5ef4f1c4d0230$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $gyZqn.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $gyZqn.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $40d5ef4f1c4d0230$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $40d5ef4f1c4d0230$var$noop, onClickAcceptAll: onClickAcceptAll = $40d5ef4f1c4d0230$var$noop, onClickPreferences: onClickPreferences = $40d5ef4f1c4d0230$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $40d5ef4f1c4d0230$var$noop, minWidth: minWidth = 400 })=>{
    const intl = (0, $5JgJ2.default)();
    const displayedTextMap = (0, $eUqFw.useMemo)(()=>{
        return $40d5ef4f1c4d0230$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $eUqFw.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $40d5ef4f1c4d0230$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $eUqFw.useCallback)(()=>{
        const displayedTextAcceptAllMap = $40d5ef4f1c4d0230$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $40d5ef4f1c4d0230$var$boxStylesBlue,
        style: {
            minWidth: `${minWidth}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $40d5ef4f1c4d0230$var$inlineWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $40d5ef4f1c4d0230$var$noticeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gyZqn.i18n).useCookiesDescription,
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyZqn.i18n).cookiesTrackingNotice))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        xcss: $40d5ef4f1c4d0230$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyZqn.i18n).preferencesBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyZqn.i18n).onlyNecessaryBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
            testId: "experiment-one-button-icon",
            label: ""
        }),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyZqn.i18n).acceptAllBtn)))));
};

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6d3cc6c41555bcf7$var$_checkMark = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("j52dF")));
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $6d3cc6c41555bcf7$var$_checkMark.default
    }));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = module.exports.default = $6d3cc6c41555bcf7$var$CheckIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43db9d99c93083272e0c42b874af3704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("cDe08", function(module, exports) {

$parcel$export(module.exports, "default", () => $3415c67bd54177b5$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $1J3ZG = parcelRequire("1J3ZG");

var $3J72S = parcelRequire("3J72S");

var $f8OZU = parcelRequire("f8OZU");

var $b4VDn = parcelRequire("b4VDn");

var $epRiJ = parcelRequire("epRiJ");

var $dI8U5 = parcelRequire("dI8U5");
const $3415c67bd54177b5$var$calculateBannerStateViaBit = (isInitialRender, initialPreferences)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender.current && shouldShowBannerBit === undefined;
    if ((0, $3J72S.isSSR)() || inFlowWhereBannerStateIsUnknown) // When coming from SSR, this hook will only execute once and won't update later
    // Instead, if we're on the server, have initial preference data with valid consents, don't render
    // On later checks (rehydration), this will always fail and skip to the normal rendering logic
    // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
    // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
    // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
    return (0, $dI8U5.shouldShowBannerInSSRContext)(initialPreferences);
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A ref to track if this is the "first" render of the component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $3415c67bd54177b5$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender })=>{
    const isEventSent = (0, $eUqFw.useRef)(false);
    const [isDismissed, setIsDismissed] = (0, $eUqFw.useState)(false);
    const showBanner = (0, $eUqFw.useMemo)(()=>{
        if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) {
            // In V1, we only checked based on the existence of the preferences aka missing or "INTERNAL" state
            const prefsMissing = preferences === (0, $epRiJ.PrefetchedPreferenceState).INTERNAL || !preferences;
            if ((0, $3J72S.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
            // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
            return !prefsMissing && !isDismissed;
            return prefsMissing && !isDismissed;
        }
        const shouldShowBanner = $3415c67bd54177b5$var$calculateBannerStateViaBit(isInitialRender, initialPreferences);
        // When preferences are unknown and not flagged as internal (e.g. undefined), show the banner
        const unknownPreferences = preferences !== (0, $epRiJ.PrefetchedPreferenceState).INTERNAL && !preferences;
        return (unknownPreferences || shouldShowBanner) && !isDismissed;
    }, [
        preferences,
        isDismissed,
        initialPreferences,
        isInitialRender
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $1J3ZG.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
var $3415c67bd54177b5$export$2e2bcd8739ae039 = $3415c67bd54177b5$var$useBannerVisibility;

});
parcelRegister("dI8U5", function(module, exports) {

$parcel$export(module.exports, "shouldShowBannerInSSRContext", () => $08750b3c3bc881c7$export$1a7f5824c34ba94b);

var $huW21 = parcelRequire("huW21");

var $k6AXN = parcelRequire("k6AXN");

var $epRiJ = parcelRequire("epRiJ");
const $08750b3c3bc881c7$export$1a7f5824c34ba94b = (initialPreferences)=>{
    if (initialPreferences === (0, $epRiJ.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
    // if the user has consented or not yet since we need to fetch, so show the banner
    return true;
    if ((0, $huW21.initialPreferencesAreMissing)(initialPreferences)) // No data at all, we need to fetch again, but hide on this pass
    return false;
    // If prefetched data has a consentToken or the consents array is there and populated
    // we want to hide the banner, as the user has has made consents already.
    const prefetchedToken = initialPreferences.consentToken;
    const prefetchedTokenIsDefault = (0, $k6AXN.checkIfTokenIsDefault)(prefetchedToken || '');
    const prefetchedConsents = initialPreferences.consents;
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const hasLegitConsents = prefetchedConsents && prefetchedConsents.length > 0;
    const prefetchedDataHasConsents = Boolean(hasLegitConsentToken || hasLegitConsents);
    const showBannerSinceUserHasNotConsented = !prefetchedDataHasConsents;
    return showBannerSinceUserHasNotConsented;
};

});


parcelRegister("htLQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aa2917c8f887b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $huW21 = parcelRequire("huW21");

var $dFvno = parcelRequire("dFvno");

var $dfZVK = parcelRequire("dfZVK");

var $epRiJ = parcelRequire("epRiJ");
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 */ const $6aa2917c8f887b87$var$usePreferences = ({ isInitialRender: isInitialRender, initialPreferences: initialPreferences })=>{
    const prefetchedPreferencesData = (0, $eUqFw.useRef)(initialPreferences);
    const [preferences, setPreferences] = (0, $eUqFw.useState)((0, $huW21.handleInitialPreferencesData)(initialPreferences));
    (0, $eUqFw.useEffect)(()=>{
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        const loadStoredPrefs = async ()=>{
            const prefs = await (0, $dFvno.getPreferences)();
            // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
            // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
            setPreferences(prefs);
            // Set the initialRender flag to false so we can skip logic in banner rendering
            isInitialRender.current = false;
        };
        const unpackedPrefetchedPrefs = (0, $huW21.handleInitialPreferencesData)(prefetchedPreferencesData.current);
        if (unpackedPrefetchedPrefs !== (0, $epRiJ.PrefetchedPreferenceState).INTERNAL) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $dfZVK.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        loadStoredPrefs();
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferences
    };
};
var $6aa2917c8f887b87$export$2e2bcd8739ae039 = $6aa2917c8f887b87$var$usePreferences;

});
parcelRegister("dFvno", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $fa3438f1c3ad82ae$export$1de6a888ae076ff8);

var $XHGTv = parcelRequire("XHGTv");

var $f8OZU = parcelRequire("f8OZU");

var $85idY = parcelRequire("85idY");

var $b4VDn = parcelRequire("b4VDn");

var $huW21 = parcelRequire("huW21");
async function $fa3438f1c3ad82ae$export$1de6a888ae076ff8() {
    // Use V001 pattern without the V2 FF enabled
    if (!(0, $XHGTv.fg)('platform.moonjelly.browser-storage-controls-v2')) {
        const packedPrefs = (0, $b4VDn.getCookie)((0, $f8OZU.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $huW21.unpackUserPreferencesCookie)(packedPrefs);
    }
    let packedLocalPrefs = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (!packedLocalPrefs) {
        const consentToken = await (0, $85idY.getConsentToken)();
        return consentToken ? (0, $huW21.unpackUserPreferencesCookie)(consentToken) : undefined;
    }
    return (0, $huW21.unpackUserPreferencesCookie)(packedLocalPrefs);
}

});
parcelRegister("85idY", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $391d5185569e2bfc$export$f1b8f2ca713fca08);

var $f8OZU = parcelRequire("f8OZU");

var $b4VDn = parcelRequire("b4VDn");

var $53MVb = parcelRequire("53MVb");

var $4TcP6 = parcelRequire("4TcP6");

var $hWRvQ = parcelRequire("hWRvQ");
const $391d5185569e2bfc$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $b4VDn.getCookie)((0, $f8OZU.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $hWRvQ.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $53MVb.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $b4VDn.getCookie)((0, $f8OZU.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $4TcP6.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $4TcP6.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $4TcP6.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("53MVb", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $e87a9db0df2659c7$export$b5282052fc15e1ae);

var $f8OZU = parcelRequire("f8OZU");

var $b4VDn = parcelRequire("b4VDn");
const $e87a9db0df2659c7$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $b4VDn.getCookie)((0, $f8OZU.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("hWRvQ", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $4f85d7ab666d3f6a$export$c515de1cc9cebc71);

var $dEf7A = parcelRequire("dEf7A");

var $huW21 = parcelRequire("huW21");
const $4f85d7ab666d3f6a$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $dEf7A.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $huW21.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});




parcelRegister("ilFhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $57331460cfa9ce06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $57331460cfa9ce06$var$usePrevious = (value)=>{
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = (0, $eUqFw.useRef)();
    // Store current value in ref
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};
var $57331460cfa9ce06$export$2e2bcd8739ae039 = $57331460cfa9ce06$var$usePrevious;

});


const $539c74e86514eccc$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $539c74e86514eccc$export$ed7cc0d417ee89e = 74;
const $539c74e86514eccc$export$ff6e18f7d82b549c = 320;



//# sourceMappingURL=async-cookie-consent-banner.2f4e645c.js.map
